<template>
  <div :class="$style.container"
       v-loading.fullscreen.lock.body="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div :class="$style.top">
      <div>
        <el-row>
          <el-col :span="20">
            <div align="left" style="padding-top: 8px; color: cornflowerblue">
              <span style="color: black; font-size: 14px">{{ product_num }}个产品 </span>
              <span style="color: black; font-size: 14px" v-if="clientObj.showInstitution">
                                &nbsp;机构 {{ tableInstutionsListLength }} 家&nbsp; | </span>
              <span style="color: black; font-size: 14px" v-if="clientObj.showStore">
                                &nbsp;门店 {{ tableRetailstoreListLength }}
                               家&nbsp; |</span>
              <span style="color: black; font-size: 14px" v-if="clientObj.showDistributor">
                            &nbsp;经销商 {{ tableDistributorListLength }} 家</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="margin-top: 10px">
                        <span v-for="(item,index) in cityList" style="font-size: 12px;
                        display: inline-block;margin-top: 5px;margin-right: 10px;
                        padding: 5px 12px;border:1px solid #FF9901;color: #FF9901;
                        border-radius: 5px">
                            {{ item.province_name }}-{{ item.city_name }}
                        </span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 40px;">
          <el-col>
            <el-button @click="addJurisdiction" type="success"
                       icon="el-icon-set-up"
                       size="small">
              辖区调整
            </el-button>
            <!--                        <el-button @click="addInstitutions" type="success"-->
            <!--                                   v-if=" isShowButton()"-->
            <!--                                       icon="el-icon-plus"-->
            <!--                                       size="small">-->
            <!--                        添加机构</el-button>-->
            <!--                        <el-button @click="addStore" type="success"-->
            <!--                                   v-if="isShowButton()"-->
            <!--                                       icon="el-icon-plus"-->
            <!--                                       size="small">-->
            <!--                        添加门店</el-button>-->
            <!--                        <el-button @click="addDistributor" type="success"-->
            <!--                                   v-if="isShowButton_D()"-->
            <!--                                       icon="el-icon-plus"-->
            <!--                                       size="small">-->
            <!--                        添加经销商</el-button>-->
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-tabs v-model="activeName" @tab-click="tabHandleClick">
            <el-tab-pane label="医疗机构" name="first" v-if="clientObj.showInstitution">
              <el-table :header-cell-style="{'color':'black','font-size':'15px'}"
                        :data="tableInstutionsList" stripe border ref="multipleTable">
                <el-table-column
                    min-width="200"
                    prop="institution_name"
                    label="名称"
                    sortable>
                </el-table-column>
                <el-table-column
                    min-width="250"
                    prop="address"
                    label="地址"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="array[0].count"
                    sortable
                    width="90"
                    label="HCP">
                </el-table-column>
                <el-table-column
                    width="180"
                    sortable
                    label="产品">
                  <template slot-scope="scope" style="text-align: center">
                                      <span class="tableSpan"
                                            v-for="(item,index) in scope.row.productArray" :key="index">
                                         {{ item.product_name }}
                                      </span>
                    <span>

                                      </span>
                  </template>
                </el-table-column>
                <el-table-column
                    label-class-name="institutions_table_cell"
                    :width="isShowButton()?160:80"
                    fixed="right" label="操作"
                >
                  <template slot-scope="scope" style="text-align: center">
                    <div class="tempCell">
                      <el-button
                          style="background: #FF9901;
                                                   border:1px solid #FF9901;color:white;" size="small"
                          @click="clickModelInstutionsList(scope.index,scope.row)">详情
                      </el-button>
                      <el-button
                          type="danger" size="small" style=""
                          v-if="isShowButton()"
                          @click="clickRemove(scope.index,scope.row)">移除
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="零售终端" name="second" v-if="clientObj.showStore">
              <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="tableRetailstoreList" stripe
                        border ref="multipleTable">
                <el-table-column
                    min-width="200"
                    sortable
                    prop="store_name"
                    label="名称"
                >
                </el-table-column>
                <el-table-column
                    min-width="250"
                    sortable
                    prop="address"
                    label="地址"
                >
                </el-table-column>
                <el-table-column
                    sortable
                    width="80"
                    prop="clerk_num"
                    label="店员">
                </el-table-column>
                <el-table-column
                    width="180"
                    sortable
                    label="产品">
                  <template slot-scope="scope" style="text-align: center">
                                      <span class="tableSpan"
                                            v-for="(item,index) in scope.row.productArray" :key="index">
                                         {{ item.product_name }}
                                      </span>
                    <span>

                                      </span>
                  </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label-class-name="institutions_table_cell"
                    :width="isShowButton()?160:80"
                    label="操作">
                  <template slot-scope="scope" style="text-align: center">
                    <div class="tempCell">
                      <el-button
                          style="background: #FF9901;
                                                   border:1px solid #FF9901;color:white;" size="small"
                          @click="clickModelRetailstoreList(scope.$index, scope.row)">详情
                      </el-button>
                      <el-button
                          type="danger" size="small" style=""
                          v-if="isShowButton()"
                          @click="clickRemoveRetailstoreList(scope.$index, scope.row)">移除
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="分销客户" name="third" v-if="clientObj.showDistributor">
              <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="tableDistributorList" stripe
                        border ref="multipleTable">
                <el-table-column
                    min-width="200"
                    sortable
                    prop="distributor_name"
                    label="名称"
                >
                </el-table-column>
                <el-table-column
                    min-width="250"
                    sortable
                    prop="address"
                    label="地址"
                >
                </el-table-column>
                <el-table-column
                    sortable
                    width="90"
                    prop="userInfo[0].count"
                    label="联系人">
                </el-table-column>
                <el-table-column
                    width="180"
                    sortable
                    label="产品">
                  <template slot-scope="scope" style="text-align: center">
                                      <span class="tableSpan"
                                            v-for="(item,index) in scope.row.productArray" :key="index">
                                         {{ item.product_name }}
                                      </span>
                    <span>

                                      </span>
                  </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label-class-name="institutions_table_cell"
                    :width="isShowButton()?160:80"
                    label="操作">
                  <template slot-scope="scope" style="text-align: center">
                    <div class="tempCell">
                      <el-button
                          style="background: #FF9901;
                                                   border:1px solid #FF9901;color:white;" size="small"
                          @click="clickModelDistributorList(scope.$index, scope.row)">详情
                      </el-button>
                      <el-button
                          type="danger" size="small" style=""
                          v-if="isShowButton()"
                          @click="clickRemoveDistributorList(scope.$index, scope.row)">移除
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </div>
    </div>

    <el-dialog title="" :visible.sync="addModelJurisdiction" width="900px" :show-close="false">
      <div slot="title" class="dialog-footer"
           style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
        <span style="color: #3998F7;font-size: 22px">辖区调整申请 </span>
        <span>
<!--                <el-button @click="saveAddInstitutions" type="primary" size="small">保存</el-button>-->
                <el-button type="danger" @click="addModelJurisdiction = false" size="small">取消</el-button>
                </span>
      </div>
      <el-steps :active="stepsName" simple finish-status="success">
        <el-step title="选择类型"></el-step>
        <el-step title="填写信息"></el-step>
        <el-step title="提交申请"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <div :style="{display:steps == 1 ? 'block' : 'none',marginTop:'20px',overflow: 'hidden'}">
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_ADD']==='T'" style="width: 80%;margin:0 auto; margin-top:20px;" @click.native="clickActiveStyle(1)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===1?'#ecf3fc':'#fff',borderColor:activeStyle===1?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/jiahao.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #7ED321;margin:20px 0px;">将现有机构移入辖区</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                将公司主数据中已经存在的机构移入到我的辖区内</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_ENROLLMENT']==='T'" style="width: 80%;margin:0 auto; margin-top:20px;" @click.native="clickActiveStyle(2)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===2?'#ecf3fc':'#fff',borderColor:activeStyle===2?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/FillAdd.png"
                   style="width: 44px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #FF9901;margin:20px 0px;">在辖区内添加新的机构</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                提交辖区内新的机构数据（该机构在公司主数据中尚不存在）</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_REMOVE']==='T'" style="width: 80%;margin:0 auto;margin-top:20px;" @click.native="clickActiveStyle(3)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===3?'#ecf3fc':'#fff',borderColor:activeStyle===3?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/jianhao.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #ED3B3F;margin:20px 0px;">将现有机构移出辖区</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                将我的辖区中已经存在的机构移出</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_LOCATION']==='T'" style="width: 80%;margin:0 auto;margin-top:20px;"
                @click.native="clickActiveStyle(4)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===4?'#ecf3fc':'#fff',borderColor:activeStyle===4?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/tiaozheng.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #d68af9;margin:20px 0px;">调整机构的签到位置坐标</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                对辖区中的机构签到位置进行修正</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px">
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="step1Click" size="small"
                       style="float: right;margin-top:20px;background: #FF9901;color: #fff;border:none;">下一步
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 2 ? 'block' : 'none'}" id="steps2">
        <el-row style="margin-top:20px;">
          <el-col :span="24" v-if="activeStyle == 2 ? false : true">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="选择机构">
                <el-select v-model="institution_id" @change="getInstitutionsFromInfo" placeholder="请选择机构" filterable
                           style="width: 100%" clearable>
                  <el-option
                      v-for="item in institutionsForm"
                      :key="item.institution_id"
                      :label="item.institution_name"
                      :value="item.institution_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24" v-if="activeStyle == 2 ? true : false">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="新机构">
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-if="activeStyle==4?false:true">
          <el-col>
            <el-tabs v-model="activeName1" @tab-click="tabHandleClick">
              <el-tab-pane label="基本信息" name="first">
                <el-row v-if="activeStyle == 2 ? true : false">
                  <el-form ref="addBasicInfoForm" label-width="130px" :model="addBasicInfoForm"
                           style="font-size: 14px;margin-top: 10px;">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="名称"
                                      prop="institution_name"
                                      :rules="[{ required: true, message: '名称不能为空'},]"
                        >
                          <el-input v-model="addBasicInfoForm.institution_name" placeholder="请输入名称"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="编码" prop="institution_code" :rules="[
                                           { required: true, message: '编码不能为空'},
                                    ]">
                          <el-input v-model="addBasicInfoForm.institution_code" placeholder="请输入编码"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="类别" prop="institution_type" :rules="[
                                           { required: true, message: '类别不能为空'},
                                    ]">
                          <el-select v-model="addBasicInfoForm.institution_type" filterable placeholder="请选择类别"
                                     style="width: 100%" @change="fangfa2" clearable>
                            <el-option
                                v-for="item in TypeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="级别">
                          <el-select v-model="addBasicInfoForm.institution_grade" filterable placeholder="请选择级别"
                                     style="width: 100%" clearable>
                            <el-option
                                v-for="item in GardeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="省份" prop="province_id"
                                      :rules="[{ required: true, message: '省份不能为空'},]"
                        >
                          <el-select v-model="addBasicInfoForm.province_id" filterable placeholder="请选择省份"
                                     @change="fangfa" style="width: 100%" clearable>
                            <el-option
                                v-for="item in data1"
                                :key="item.province_id"
                                :label="item.province_name"
                                :value="item.province_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="城市" prop="city_id" :rules="[
                                           { required: true, message: '城市不能为空'},
                                    ]">
                          <el-select v-model="addBasicInfoForm.city_id" filterable placeholder="请选择城市"
                                     style="width: 100%" clearable>
                            <el-option
                                v-for="item in CityList"
                                :key="item.city_id"
                                :label="item.city_name"
                                :value="item.city_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="地址">
                          <el-input v-model="addBasicInfoForm.address" placeholder="请输入地址"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="联系电话">
                          <el-input v-model="addBasicInfoForm.telephone" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="邮政编码">
                          <el-input v-model="addBasicInfoForm.postcode" placeholder="请输入邮政编码"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="官方网址">
                          <el-input v-model="addBasicInfoForm.website" placeholder="请输入官方网址"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="所属经销商">

                          <el-select v-model="addBasicInfoForm.distributor_id" filterable placeholder="请选择经销商"
                                     style="width: 100%" clearable>
                            <el-option
                                v-for="item in distributorList"
                                :key="item.distributor_id"
                                :label="item.distributor_name"
                                :value="item.distributor_id">
                            </el-option>
                          </el-select>

                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="开发进度">
                          <el-select v-model="addBasicInfoForm.agreement_stage" placeholder="请选择开发进度"
                                     style="width: 100%">
                            <el-option
                                v-for="item in  INSTITUTION_AGREEMENT_STAGE"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="已进药">
                          <el-switch
                              v-model="addBasicInfoForm.agreement_signed"
                              active-color="#13ce66"
                              active-value="T"
                              inactive-value="F"
                          >
                          </el-switch>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </el-row>
                <el-row v-else>
                  <el-form ref="form" label-width="130px" :model="basicInfoForm"
                           style="font-size: 14px;margin-top: 10px;">
                    <el-col :span="12">
                      <el-form-item label="名称">
                        <el-input v-model="basicInfoForm.institution_name" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="编码">
                        <el-input v-model="basicInfoForm.institution_code" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="类别">
                        <el-select v-model="basicInfoForm.institution_type" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in TypeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="级别">
                        <el-select v-model="basicInfoForm.institution_grade" placeholder="" disabled
                                   style="width: 100%">
                          <el-option
                              v-for="item in GardeList1"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="省份">
                        <el-select v-model="basicInfoForm.province_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in data1"
                              :key="item.province_id"
                              :label="item.province_name"
                              :value="item.province_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="城市">
                        <el-select v-model="basicInfoForm.city_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in CityList1"
                              :key="item.city_id"
                              :label="item.city_name"
                              :value="item.city_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="地址">
                        <el-input v-model="basicInfoForm.address" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话">
                        <el-input v-model="basicInfoForm.telephone" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="邮政编码">
                        <el-input v-model="basicInfoForm.postcode" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="官方网址">
                        <el-input v-model="basicInfoForm.website" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="所属经销商">
                        <el-select v-model="basicInfoForm.distributor_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in distributorList"
                              :key="item.distributor_id"
                              :label="item.distributor_name"
                              :value="item.distributor_id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开发进度">
                        <el-select v-model="basicInfoForm.agreement_stage" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in  INSTITUTION_AGREEMENT_STAGE"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="已进药">
                        <el-switch
                            v-model="basicInfoForm.agreement_signed"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            disabled>
                        </el-switch>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </el-tab-pane>
              <el-tab-pane v-if="activeStyle == 2 ? true : false" :label="items.group_name" :name="items.name"
                           v-for="(items,i) in extendedInfo1_2">
                <div class="subjectList" style="margin-top: 20px;">
                  <el-form :ref="'extendedInfo1_2'+i+j" label-width="30%" v-for="(item,j) in items.fieldArray"
                           :model="item" :key="item.field_id">
                    <el-col span="24" v-if="item.input_type == 'TEXT'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input v-model="item.field_value" placeholder="请输入文本"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'DATE'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-date-picker
                            v-model="item.field_value"
                            type="date"
                            placeholder="选择日期时间"
                            style="width: 100%"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :disabled="item.readonly == 'T'">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                      <el-form-item :label="item.label"

                      >
                        <el-switch
                            v-model="item.field_value"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            :disabled="item.readonly == 'T'"
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'LIST'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <!--                                            <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" :disabled="item.readonly == 'T'" clearable>-->
                        <!--                                                <el-option-->
                        <!--                                                        v-for="item in item.listArray"-->
                        <!--                                                        :key="item.value"-->
                        <!--                                                        :label="item.label"-->
                        <!--                                                        :value="item.value">-->
                        <!--                                                </el-option>-->
                        <!--                                            </el-select>-->
                        <el-cascader
                            v-model="item.field_value"
                            :options="item.listArray"
                            style="width: 100%"
                            filterable
                            :show-all-levels="false"
                            :disabled="item.readonly == 'T'"
                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                            clearable></el-cascader>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-table
                            :data="item.field_value"
                            border
                            style="width: 100%">
                          <el-table-column
                              type="index"
                              label="序号"
                              width="50">
                          </el-table-column>
                          <el-table-column
                              prop="dept_name"
                              label="标准科室"
                              v-if="item.array_dept !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="product_name"
                              label="产品"
                              v-if="item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="sku_name"
                              label="SKU"
                              v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="date_name"
                              label="日期"
                              v-if="item.array_date !== 'NONE' "
                          >
                          </el-table-column>
                          <el-table-column
                              prop="field_value"
                              label="数值"
                          >
                          </el-table-column>
                          <el-table-column
                              fixed="right"
                              label="操作"
                              width="80">
                            <template slot-scope="scope">
                              <el-button @click="handleTableClick(scope.$index, scope.row,item)"
                                         style="background-color: rgb(255, 153, 1);border: 1px solid rgb(255, 153, 1);color: #fff"
                                         size="small">详情
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-form-item>
                      <el-col :span="24" style="margin-bottom: 10px;">
                        <el-button size="small" icon="el-icon-plus"
                                   style="float: left;margin-left: 30%;background-color:#6cc584;border: 1px solid #6cc584;color:#fff"
                                   @click="addNewTable(item)">添加新数据
                        </el-button>
                      </el-col>
                      <el-col :span="24" v-if="item.isAddTable" id="addTable"
                              style="margin-left: 30%;width:70%;background: #edf3fb;border: 1px solid #ecdfe6;margin-bottom:10px;border-radius: 10px;">
                        <el-col :span="14">
                          <el-form ref="addTable1" :model="item.addTableList" style="margin-top:20px">
                            <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id"
                                          :rules="{ required: true, message: '标准科室不能为空'}">
                              <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                                         style="width: 70%;float: right" clearable>
                                <el-option
                                    v-for="item in administrativeList"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="产品" v-if="item.array_product !== 'NONE'" prop="product_id"
                                          :rules="{ required: true, message: '产品不能为空'}">
                              <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                                         style="width: 70%;float: right" @change="getSkuList(item)" clearable>
                                <el-option
                                    v-for="item in productList1"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="SKU"
                                          v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                          prop="sku_id"
                                          :rules="{ required: true, message: 'SKU不能为空'}">
                              <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                                         style="width: 70%;float: right" clearable>
                                <el-option
                                    v-for="item in SkuList"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="日期" v-if="item.array_date !== 'NONE' && item.array_date !== ''"
                                          prop="info_date" :class="{home_star:true}"
                                          :rules="{ required: true, message: '日期不能为空'}">
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="year"
                                  style="width: 70%;float: right"
                                  format="yyyy年"
                                  value-format="yyyy年"
                                  placeholder="选择年"
                                  v-if="item.array_date == 'YEAR'"
                              >
                              </el-date-picker>
                              <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                                       :defaultValue="item.addTableList.info_date" :getValue="getQuarterValue"
                                       style="width: 70%;float: right"></quarter>
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="month"
                                  style="width: 70%;float: right"
                                  format="yyyy年MM月"
                                  value-format="yyyy年MM月"
                                  placeholder="选择月"
                                  v-if="item.array_date == 'MONTH'"
                              >
                              </el-date-picker>
                              <monthComponent v-if="item.array_date == 'WEEK'" @week-event="parentWeekEvent"
                                              :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                                              style="width: 70%;float: right"></monthComponent>
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="date"
                                  placeholder="选择日期"
                                  style="width: 70%;float: right"
                                  format="yyyy年MM月dd日"
                                  value-format="yyyy年MM月dd日"
                                  v-if="item.array_date == 'DAY'"
                              >
                              </el-date-picker>
                            </el-form-item>
                            <el-form-item label="数值" prop="field_value"
                                          :rules="{ required: true, message: '数值不能为空'}">
                              <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                                        style="width: 70%;float: right" type="number"></el-input>
                            </el-form-item>
                          </el-form>

                        </el-col>
                        <el-col :span="10">
                          <el-col style="margin-top:20px;">
                            <el-button size="small"
                                       style="float: left;margin-left: 40px;background-color:#588ede;border: 1px solid #588ede;color:#fff"
                                       @click="addTableDataIns(item)">保存
                            </el-button>
                            <el-button
                                style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                @click="delateTableData(item)" v-if="delateFalse" size="small">删除
                            </el-button>
                            <el-button size="small"
                                       style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                       @click="cancelTableData(item)">取消
                            </el-button>
                          </el-col>

                        </el-col>
                      </el-col>
                    </el-col>

                    <el-col span="24" v-else>
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="activeStyle == 1 || activeStyle == 3" :label="items.group_name" :name="items.name"
                           v-for="(items,j) in extendedInfo">
                <div class="subjectList" style="margin-top: 20px;">
                  <el-form :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item"
                           :key="item.field_id">
                    <el-col span="24" v-if="item.input_type == 'TEXT'">
                      <el-form-item :label="item.label"

                      >
                        <el-input v-model="item.field_value" placeholder="" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                      <el-form-item :label="item.label"

                      >
                        <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'DATE'">
                      <el-form-item :label="item.label"

                      >
                        <el-date-picker
                            v-model="item.field_value"
                            type="date"
                            placeholder=""
                            style="width: 100%"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            disabled>
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                      <el-form-item :label="item.label"

                      >
                        <el-switch
                            v-model="item.field_value"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            disabled
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'LIST'">
                      <el-form-item :label="item.label"

                      >
                        <el-cascader
                            v-model="item.field_value"
                            :options="item.listArray"
                            style="width: 100%"
                            filterable
                            disabled
                            placeholder=""
                            :show-all-levels="false"
                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                            clearable></el-cascader>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                      <el-form-item :label="item.label"

                      >
                        <el-table
                            :data="item.field_value"
                            border
                            style="width: 100%">
                          <el-table-column
                              type="index"
                              label="序号"
                              width="50">
                          </el-table-column>
                          <el-table-column
                              prop="dept_name"
                              label="标准科室"
                              v-if="item.array_dept !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="product_name"
                              label="产品"
                              v-if="item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="sku_name"
                              label="SKU"
                              v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="date_name"
                              label="日期"
                              v-if="item.array_date !== 'NONE' "
                          >
                          </el-table-column>
                          <el-table-column
                              prop="field_value"
                              label="数值"
                          >
                          </el-table-column>

                        </el-table>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else>
                      <el-form-item :label="item.label"

                      >
                        <el-input :rows="3" v-model="item.field_value" placeholder="" type="textarea"
                                  disabled></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>

              <el-tab-pane label="签到位置" v-if="activeStyle == 2 ? true : false" name="third">
                <div class="amap-page-container" style="height: 300px">
                  <el-amap-search-box
                      :default="searchStr"
                      class="search-box"
                      :search-option="searchOption"
                      :on-search-result="onSearchResult1"
                      style="position: relative;top: 20px;left: 20px"
                  ></el-amap-search-box>
                  <el-amap
                      vid="mapDemo1"
                      :center="center1_1"
                      :zoom="12"
                      :plugin="plugin"
                      :amapManager="amapManager"
                      class="amap-demo"
                      style="position: relative;top:-60px;"
                  >
                    <el-amap-marker :position="marker" :draggable="true" :events="edit_markers1.events"
                                    v-for="marker in centers1_1">
                    </el-amap-marker>
                  </el-amap>
                </div>
                <div style="margin-top: 10px" class="amap">
                  <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                    <el-form-item label="名称">

                      <el-input v-model="locationForm.location_name"></el-input>

                    </el-form-item>
                    <el-form-item label="地址">

                      <el-input v-model="locationForm.address"></el-input>

                    </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane label="签到位置" v-else name="third">
                <div class="amap-page-container" style="height: 300px">
                  <el-amap
                      vid="mapDemo1_1"
                      :center="center"
                      :zoom="12"
                      :plugin="plugin"
                      :amapManager="amapManager"
                      class="amap-demo"
                      style="position: relative;"
                  >
                    <el-amap-marker

                        :position="center.position"
                        :template="center.template"
                        :events="center.events"
                        v-for="center in centers">
                    </el-amap-marker>
                  </el-amap>
                </div>
                <div style="margin-top: 10px" class="amap">
                  <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                    <el-form-item label="名称">

                      <el-input v-model="locationForm.location_name" disabled></el-input>

                    </el-form-item>
                    <el-form-item label="地址">

                      <el-input v-model="locationForm.address" disabled></el-input>

                    </el-form-item>
                  </el-form>
                </div>

              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col>
            <div :style="{width:'100%',height:'62px',padding:'10px 0px',overflow:'hidden',position:'relative'}">
              <div style="width:20px;height: 20px;position: absolute;top: 32px;left:0px; cursor:pointer;"
                   @click="locationLeftBut">
                <img src="../../assets/images/locationLeft.png" style="width: 20px;height: 20px;">
              </div>
              <div style="width:50px;height: 50px;float: left;margin-top:6px;margin-left: 35px;cursor:pointer;"
                   @click.stop="addLocation" @click="dialog1 = true">
                <img src="../../assets/images/locationAdd.png" style="width: 50px;height: 50px;">
              </div>
              <div style="float:left;height: 62px;width:85%;overflow:hidden">
                <div style=";;height: 62px;position: relative;white-space: nowrap;transition: .3s;"
                     :style="{'left':marginValue +'px' ,'width':widthLocation}"
                >
                  <div
                      :style="{width: '250px',height: '60px',border:'1px solid #ccc',marginLeft: '10px',marginBottom: '10px',backgroundColor:mydiv===j?'#ecf3fc':'#fff',borderColor:mydiv===j?'#4A90E2':'#ededed',}"
                      v-for="(item,j) in locationInfo"
                      @click="InstitutionClient(item,j)" class="mydiv"
                      style="display: inline-block;white-space: nowrap;"
                  >
                    <div style="float: left">
                      <p style="margin:20px 10px;background: #999;color: #fff;border-radius: 50%;width: 20px;height: 20px;text-align: center;line-height: 20px;">
                        {{ j + 1 }}</p>
                    </div>
                    <div style="float: left">
                      <p style="padding: 10px 0px;margin: 0;color: #4A4A4A;font-size: 16px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ item.location_name }}</p>
                      <p style="padding: 0px 0px;margin: 0;color: #B0B5B9;font-size: 14px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ item.address }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div style="width:20px;height: 20px;position: absolute;top: 32px;right:0px; cursor:pointer;"
                   @click="locationRightBut">
                <img src="../../assets/images/locationRight.png" style="width: 20px;height: 20px;">
              </div>
            </div>
          </el-col>
          <el-col>
            <div class="amap-page-container" style="height: 300px">
              <el-amap-search-box
                  :default="searchStr"
                  class="search-box"
                  :search-option="searchOption"
                  :on-search-result="onSearchResult4"
                  style="position: relative;top: 20px;left: 20px;height:35px"
              ></el-amap-search-box>
              <el-amap
                  vid="mapDemo1_2"
                  :center="center4_1"
                  :zoom="12"
                  :plugin="plugin"
                  :amapManager="amapManager"
                  class="amap-demo"
                  style="position: relative;top:-30px;margin: 0"
              >
                <el-amap-marker :position="marker" :visible="true" :draggable="true" :events="edit_markers.events"
                                v-for="marker in markers">
                </el-amap-marker>
              </el-amap>
            </div>
            <div style="margin-top: 30px" class="amap">
              <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                <el-form-item label="名称">

                  <el-input v-model="locationForm.location_name" @input="change1"></el-input>

                </el-form-item>
                <el-form-item label="地址">

                  <el-input v-model="locationForm.address" @input="change2"></el-input>

                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="steps2Click" size="small"
                       style="float: left;margin-top:20px;background: #FF9901;color: #fff;border:none;">上一步
            </el-button>
            <el-button @click="steps3Click" size="small"
                       style="float: right;margin-top:20px;background: #FF9901;color: #fff;border:none;">下一步
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 3 ? 'block' : 'none'}" id="steps3">
        <el-row style="margin-top:20px;">
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="调整类型">
                <p style="margin:0; font-size: 16px;color:#7ED321;" v-if="activeStyle == 1 ? true:false">将现有机构移入辖区</p>
                <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="activeStyle == 2 ? true:false">在辖区内添加新的机构</p>
                <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="activeStyle == 3 ? true:false">将现有机构移出辖区</p>
                <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="activeStyle == 4 ? true:false">调整机构的签到位置坐标</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="机构名称">
                <p v-if="activeStyle == 2 ? true:false" style="margin:0;font-size: 16px;color:#4A90E2;">
                  {{ addBasicInfoForm.institution_name }}</p>
                <p v-else style="margin:0;font-size: 16px;color:#4A90E2;">{{ basicInfoForm.institution_name }}</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-form ref="institutionForm" label-width="130px" :model="jurisdictionForm" style="font-size: 14px">
            <el-col :span="24">
              <el-form-item label="推广产品" prop="productArray" >
                <el-select v-model="jurisdictionForm.productArray" style="width: 100%"
                           v-if="activeStyle == 3||activeStyle == 4" multiple
                           :disabled="activeStyle == 3||activeStyle == 4 ? true: false" placeholder="">
                  <el-option
                      v-for="item in productList1"
                      :key="item.key"
                      :label="item.value1"
                      :value="item.key"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="jurisdictionForm.productArray" style="width: 100%" v-else multiple
                           :disabled="activeStyle == 3||this.activeStyle==4 ? true: false" placeholder="请选择推广产品">
                  <el-option
                      v-for="item in territoryProductArray"
                      :key="item.product_id"
                      :label="item.product_name"
                      :value="item.product_id">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="24">
              <el-form-item label="申请理由">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入申请理由"
                    v-model="jurisdictionForm.textarea">
                </el-input>
              </el-form-item>
            </el-col>

          </el-form>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="steps4Click" size="small"
                       style="float: left;margin-top:20px;background: #FF9901;color: #fff;border:none;">上一步
            </el-button>
            <el-button type="primary" @click="steps5Click" size="small" style="float: right;margin-top:20px;">立即提交
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 4 ? 'block' : 'none'}" id="steps4">
        <el-row style="margin-top:20px;">
          <el-col :span="24">
            <img src="../../assets/images/applySuccess.png"
                 style="width: 100px;height: 100px;display: block;margin:0 auto;">
            <p style="font-size: 20px;color: #FF9901;text-align: center;margin-top:20px;margin-bottom: 0px;">
              以下申请已成功提交，请等待主管审批</p>
          </el-col>
        </el-row>
        <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 70%;height: 220px;margin:20px auto;">
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="margin-top:10px;height: 40px">
              <el-form-item label="调整类型">
                <p style="margin:0; font-size: 16px;color:#7ED321;" v-if="activeStyle == 1 ? true:false">将现有机构移入辖区</p>
                <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="activeStyle == 2 ? true:false">在辖区内添加新的机构</p>
                <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="activeStyle == 3 ? true:false">将现有机构移出辖区</p>
                <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="activeStyle == 4 ? true:false">调整机构的签到位置坐标</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24" style="height: 40px;">
            <el-form ref="form" label-width="130px" :model="form">
              <el-form-item label="机构名称">
                <p v-if="activeStyle == 2 ? true:false" style="margin:0;font-size: 16px;color:#4A90E2;">
                  {{ addBasicInfoForm.institution_name }}</p>
                <p v-else style="margin:0;font-size: 16px;color:#4A90E2;">{{ basicInfoForm.institution_name }}</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-form ref="form" label-width="130px" :model="jurisdictionForm" style="font-size: 14px">
            <!--                        <el-col :span="24" style="height: 40px;">-->
            <!--                            <el-form-item label="生效日期">-->
            <!--                                <p  style="margin:0;color: #87909A;">{{jurisdictionForm.effective_date == 'C' ? '本月生效' : '次月生效'}}</p>-->
            <!--                            </el-form-item>-->
            <!--                        </el-col>-->
            <el-col :span="24" style="height: 40px;" v-if="activeStyle==4">
              <el-form-item label="推广产品">
                                 <span v-for="(item,j) in jurisdictionForm.productArray" >
                                    <span v-for="(a,b) in productList1" v-if="item == a.key"
                                          style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{
                                        a.value1
                                      }}</span>
                                </span>

              </el-form-item>
            </el-col>
            <el-col :span="24" style="height: 40px;" v-else>
              <el-form-item label="推广产品">
                <span v-for="(item,j) in jurisdictionForm.productArray" >
                                    <span v-for="(a,b) in territoryProductArray" v-if="item == a.product_id"
                                          style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{
                                        a.product_name
                                      }}</span>
                                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="height: 40px;">
              <el-form-item label="申请理由">
                <p style="margin:0;color: #87909A;">{{ jurisdictionForm.textarea }}</p>
              </el-form-item>

            </el-col>
          </el-form>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">

            <el-button type="success" @click.stop="steps6Click" @click="addModelJurisdiction = false" size="small"
                       style="float: right;margin-top:20px;">完成
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="addModelJurisdiction2" width="900px" :show-close="false">
      <div slot="title" class="dialog-footer"
           style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
        <span style="color: #3998F7;font-size: 22px">辖区调整申请 </span>
        <span>
<!--                <el-button @click="saveAddInstitutions" type="primary" size="small">保存</el-button>-->
                <el-button type="danger" @click="addModelJurisdiction2 = false" size="small">取消</el-button>
                </span>
      </div>
      <el-steps :active="stepsName" simple finish-status="success">
        <el-step title="选择类型"></el-step>
        <el-step title="填写信息"></el-step>
        <el-step title="提交申请"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <div :style="{display:steps == 1 ? 'block' : 'none',marginTop:'20px',overflow: 'hidden'}">
        <el-row  v-if="systemConfig['ENABLE_TERRITORY_CLIENT_ADD']==='T'" style="width: 80%;margin:0 auto; margin-top:20px;" @click.native="clickActiveStyle(1)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===1?'#ecf3fc':'#fff',borderColor:activeStyle===1?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/jiahao.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #7ED321;margin:20px 0px;">将现有门店移入辖区</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                将公司主数据中已经存在的门店移入到我的辖区内</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row  v-if="systemConfig['ENABLE_TERRITORY_CLIENT_ENROLLMENT']==='T'" style="width: 80%;margin:0 auto; margin-top:20px;" @click.native="clickActiveStyle(2)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===2?'#ecf3fc':'#fff',borderColor:activeStyle===2?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/FillAdd.png"
                   style="width: 44px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #FF9901;margin:20px 0px;">在辖区内添加新的门店</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                提交辖区内新的门店数据（该门店在公司主数据中尚不存在）</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row  v-if="systemConfig['ENABLE_TERRITORY_CLIENT_REMOVE']==='T'" style="width: 80%;margin:0 auto;margin-top:20px;" @click.native="clickActiveStyle(3)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===3?'#ecf3fc':'#fff',borderColor:activeStyle===3?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/jianhao.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #ED3B3F;margin:20px 0px;">将现有门店移出辖区</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                将我的辖区中已经存在的门店移出</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row  v-if="systemConfig['ENABLE_TERRITORY_CLIENT_LOCATION']==='T'" style="width: 80%;margin:0 auto;margin-top:20px;"
                @click.native="clickActiveStyle(4)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===4?'#ecf3fc':'#fff',borderColor:activeStyle===4?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/tiaozheng.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #d68af9;margin:20px 0px;">调整门店的签到位置坐标</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                对辖区中的门店签到位置进行修正</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px">
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="step1Click" size="small"
                       style="float: right;margin-top:20px;background: #FF9901;color: #fff;border:none;">下一步
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 2 ? 'block' : 'none'}" id="steps2_1">
        <el-row style="margin-top:20px;">
          <el-col :span="24" v-if="activeStyle == 2 ? false : true">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="选择门店">
                <el-select v-model="store_id" @change="getStoreFromInfo" placeholder="请选择门店" filterable
                           style="width: 100%" clearable>
                  <el-option
                      v-for="item in storeForm"
                      :key="item.store_id"
                      :label="item.store_name"
                      :value="item.store_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24" v-if="activeStyle == 2 ? true : false">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="新门店">
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-if="activeStyle==4?false:true">
          <el-col>
            <el-tabs v-model="activeName1">
              <el-tab-pane label="基本信息" name="first">
                <el-row v-if="activeStyle == 2 ? true : false">
                  <el-form ref="pushStoreList" :model="pushStoreList" label-width="130px"
                           style="font-size: 14px;margin-top: 10px;">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="名称" prop="store_name" :rules="[{ required: true, message: '名称不能为空'},]">
                          <el-input v-model="pushStoreList.store_name" placeholder="请输入名称"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="编码" prop="store_code" :rules="[{ required: true, message: '编码不能为空'},]">
                          <el-input v-model="pushStoreList.store_code" placeholder="请输入编码"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>


                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="类别" prop="store_type" :rules="[{ required: true, message: '类别不能为空'},]">
                          <el-select v-model="pushStoreList.store_type" placeholder="请选择" style="width: 100%"
                                     @change="fangfa2_1" clearable>
                            <el-option
                                v-for="item in storeTypeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="级别">
                          <el-select v-model="pushStoreList.retailstore_grade" placeholder="请选择" style="width: 100%"
                                     clearable>
                            <el-option
                                v-for="item in storeGardeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="省份" prop="province_id" :rules="[{ required: true, message: '省份不能为空'},]">
                          <el-select v-model="pushStoreList.province_id" placeholder="请选择" style="width: 100%"
                                     @change="fangfa2_2" clearable>
                            <el-option
                                v-for="item in data1"
                                :key="item.province_id"
                                :label="item.province_name"
                                :value="item.province_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="城市" prop="city_id" :rules="[{ required: true, message: '城市不能为空'},]">
                          <el-select v-model="pushStoreList.city_id" placeholder="请选择" style="width: 100%" clearable>
                            <el-option
                                v-for="item in storeCityList"
                                :key="item.city_id"
                                :label="item.city_name"
                                :value="item.city_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="所属医疗机构">
                          <el-select v-model="pushStoreList.institution_id" filterable placeholder="请选择"
                                     style="width: 100%" clearable>
                            <el-option
                                v-for="item in institutionList"
                                :key="item.institution_id"
                                :label="item.institution_name"
                                :value="item.institution_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="地址">
                          <el-input v-model="pushStoreList.address" placeholder="请输入地址"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>


                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="联系电话">
                          <el-input v-model="pushStoreList.telephone" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="邮政编码">
                          <el-input v-model="pushStoreList.postcode" placeholder="请输入邮政编码"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="官方网址">
                          <el-input v-model="pushStoreList.website" placeholder="请输入网址"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="所属经销商">

                          <el-select v-model="pushStoreList.distributor_id" filterable placeholder="请选择经销商"
                                     style="width: 100%" clearable>
                            <el-option
                                v-for="item in distributorList"
                                :key="item.distributor_id"
                                :label="item.distributor_name"
                                :value="item.distributor_id">
                            </el-option>
                          </el-select>

                        </el-form-item>
                      </el-col>
                    </el-row>


                    <el-col :span="12">
                      <el-form-item label="开发进度">
                        <el-select v-model="pushStoreList.agreement_stage" placeholder="请选择开发进度" style="width: 100%">
                          <el-option
                              v-for="item in RETAILSTORE_AGREEMENT_STAGE"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="已进药">
                        <el-switch
                            v-model="pushStoreList.agreement_signed"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>

                  </el-form>
                </el-row>
                <el-row v-else>
                  <el-form ref="form" label-width="130px" :model="basicInfoForm"
                           style="font-size: 14px;margin-top: 10px;">
                    <el-col :span="12">
                      <el-form-item label="名称">
                        <el-input v-model="basicInfoForm.store_name" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="编码">
                        <el-input v-model="basicInfoForm.store_code" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="类别">
                        <el-select v-model="basicInfoForm.store_type" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in storeTypeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="级别">
                        <el-select v-model="basicInfoForm.retailstore_grade" placeholder="" disabled
                                   style="width: 100%">
                          <el-option
                              v-for="item in storeGardeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="省份">
                        <el-select v-model="basicInfoForm.province_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in data1"
                              :key="item.province_id"
                              :label="item.province_name"
                              :value="item.province_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="城市">
                        <el-select v-model="basicInfoForm.city_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in CityList1"
                              :key="item.city_id"
                              :label="item.city_name"
                              :value="item.city_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="所属医疗机构">
                        <el-select v-model="basicInfoForm.institution_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in institutionList"
                              :key="item.institution_id"
                              :label="item.institution_name"
                              :value="item.institution_id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地址">
                        <el-input v-model="basicInfoForm.address" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话">
                        <el-input v-model="basicInfoForm.telephone" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="邮政编码">
                        <el-input v-model="basicInfoForm.postcode" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="官方网址">
                        <el-input v-model="basicInfoForm.website" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="所属经销商">
                        <el-select v-model="basicInfoForm.distributor_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in distributorList"
                              :key="item.distributor_id"
                              :label="item.distributor_name"
                              :value="item.distributor_id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开发进度">
                        <el-select v-model="basicInfoForm.agreement_stage" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in RETAILSTORE_AGREEMENT_STAGE"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="已进药">
                        <el-switch
                            v-model="basicInfoForm.agreement_signed"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            disabled>
                        </el-switch>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </el-tab-pane>
              <el-tab-pane v-if="activeStyle == 2 ? true : false" :label="items.group_name" :name="items.name"
                           v-for="(items,i) in extendedInfo2_2">
                <div class="subjectList" style="margin-top: 20px;">
                  <el-form :ref="'extendedInfo2_2'+i+j" label-width="30%" v-for="(item,j) in items.fieldArray"
                           :model="item" :key="item.field_id">
                    <el-col span="24" v-if="item.input_type == 'TEXT'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input v-model="item.field_value" placeholder="请输入文本"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'DATE'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-date-picker
                            v-model="item.field_value"
                            type="date"
                            placeholder="选择日期时间"
                            style="width: 100%"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :disabled="item.readonly == 'T'">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                      <el-form-item :label="item.label"

                      >
                        <el-switch
                            v-model="item.field_value"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            :disabled="item.readonly == 'T'"
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'LIST'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <!--                                            <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" :disabled="item.readonly == 'T'" clearable>-->
                        <!--                                                <el-option-->
                        <!--                                                        v-for="item in item.listArray"-->
                        <!--                                                        :key="item.value"-->
                        <!--                                                        :label="item.label"-->
                        <!--                                                        :value="item.value">-->
                        <!--                                                </el-option>-->
                        <!--                                            </el-select>-->
                        <el-cascader
                            v-model="item.field_value"
                            :options="item.listArray"
                            style="width: 100%"
                            filterable
                            :show-all-levels="false"
                            :disabled="item.readonly == 'T'"
                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                            clearable></el-cascader>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-table
                            :data="item.field_value"
                            border
                            style="width: 100%">
                          <el-table-column
                              type="index"
                              label="序号"
                              width="50">
                          </el-table-column>
                          <el-table-column
                              prop="dept_name"
                              label="标准科室"
                              v-if="item.array_dept !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="product_name"
                              label="产品"
                              v-if="item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="sku_name"
                              label="SKU"
                              v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="date_name"
                              label="日期"
                              v-if="item.array_date !== 'NONE' "
                          >
                          </el-table-column>
                          <el-table-column
                              prop="field_value"
                              label="数值"
                          >
                          </el-table-column>
                          <el-table-column
                              fixed="right"
                              label="操作"
                              width="80">
                            <template slot-scope="scope">
                              <el-button @click="handleTableClick(scope.$index, scope.row,item)"
                                         style="background-color: rgb(255, 153, 1);border: 1px solid rgb(255, 153, 1);color: #fff"
                                         size="small">详情
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-form-item>
                      <el-col :span="24" style="margin-bottom: 10px;">
                        <el-button size="small" icon="el-icon-plus"
                                   style="float: left;margin-left: 30%;background-color:#6cc584;border: 1px solid #6cc584;color:#fff"
                                   @click="addNewTable(item)">添加新数据
                        </el-button>
                      </el-col>
                      <el-col :span="24" v-if="item.isAddTable" id="addTable2"
                              style="margin-left: 30%;width:70%;background: #edf3fb;border: 1px solid #ecdfe6;margin-bottom:10px;border-radius: 10px;">
                        <el-col :span="14">
                          <el-form ref="addTable1" :model="item.addTableList" style="margin-top:20px">
                            <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id"
                                          :rules="{ required: true, message: '标准科室不能为空'}">
                              <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                                         style="width: 70%;float: right" clearable>
                                <el-option
                                    v-for="item in administrativeList"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="产品" v-if="item.array_product !== 'NONE'" prop="product_id"
                                          :rules="{ required: true, message: '产品不能为空'}">
                              <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                                         style="width: 70%;float: right" @change="getSkuList(item)" clearable>
                                <el-option
                                    v-for="item in productList1"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="SKU"
                                          v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                          prop="sku_id"
                                          :rules="{ required: true, message: 'SKU不能为空'}">
                              <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                                         style="width: 70%;float: right" clearable>
                                <el-option
                                    v-for="item in SkuList"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="日期" v-if="item.array_date !== 'NONE' && item.array_date !== ''"
                                          prop="info_date" :class="{home_star:true}"
                                          :rules="{ required: true, message: '日期不能为空'}">
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="year"
                                  style="width: 70%;float: right"
                                  format="yyyy年"
                                  value-format="yyyy年"
                                  placeholder="选择年"
                                  v-if="item.array_date == 'YEAR'"
                              >
                              </el-date-picker>
                              <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                                       :defaultValue="item.addTableList.info_date" :getValue="getQuarterValue"
                                       style="width: 70%;float: right"></quarter>
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="month"
                                  style="width: 70%;float: right"
                                  format="yyyy年MM月"
                                  value-format="yyyy年MM月"
                                  placeholder="选择月"
                                  v-if="item.array_date == 'MONTH'"
                              >
                              </el-date-picker>
                              <monthComponent v-if="item.array_date == 'WEEK'" @week-event="parentWeekEvent"
                                              :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                                              style="width: 70%;float: right"></monthComponent>
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="date"
                                  placeholder="选择日期"
                                  style="width: 70%;float: right"
                                  format="yyyy年MM月dd日"
                                  value-format="yyyy年MM月dd日"
                                  v-if="item.array_date == 'DAY'"
                              >
                              </el-date-picker>
                            </el-form-item>
                            <el-form-item label="数值" prop="field_value"
                                          :rules="{ required: true, message: '数值不能为空'}">
                              <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                                        style="width: 70%;float: right" type="number"></el-input>
                            </el-form-item>
                          </el-form>

                        </el-col>
                        <el-col :span="8">
                          <el-col style="margin-top:20px;">
                            <el-button size="small"
                                       style="float: left;margin-left: 40px;background-color:#588ede;border: 1px solid #588ede;color:#fff"
                                       @click="addTableDataStore(item)">保存
                            </el-button>
                            <el-button size="small"
                                       style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                       @click="cancelTableData(item)">取消
                            </el-button>
                          </el-col>

                        </el-col>
                      </el-col>
                    </el-col>

                    <el-col span="24" v-else>
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="activeStyle == 1 || activeStyle == 3" :label="items.group_name" :name="items.name"
                           v-for="(items,j) in extendedInfo2">
                <div class="subjectList" style="margin-top: 20px;">
                  <el-form :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item"
                           :key="item.field_id">
                    <el-col span="24" v-if="item.input_type == 'TEXT'">
                      <el-form-item :label="item.label"

                      >
                        <el-input v-model="item.field_value" placeholder="" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                      <el-form-item :label="item.label"

                      >
                        <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'DATE'">
                      <el-form-item :label="item.label"

                      >
                        <el-date-picker
                            v-model="item.field_value"
                            type="date"
                            placeholder=""
                            style="width: 100%"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            disabled>
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                      <el-form-item :label="item.label"

                      >
                        <el-switch
                            v-model="item.field_value"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            disabled
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'LIST'">
                      <el-form-item :label="item.label"

                      >
                        <el-cascader
                            v-model="item.field_value"
                            :options="item.listArray"
                            style="width: 100%"
                            filterable
                            disabled
                            placeholder=""
                            :show-all-levels="false"
                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                            clearable></el-cascader>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                      <el-form-item :label="item.label"

                      >
                        <el-table
                            :data="item.field_value"
                            border
                            style="width: 100%">
                          <el-table-column
                              type="index"
                              label="序号"
                              width="50">
                          </el-table-column>
                          <el-table-column
                              prop="dept_name"
                              label="标准科室"
                              v-if="item.array_dept !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="product_name"
                              label="产品"
                              v-if="item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="sku_name"
                              label="SKU"
                              v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="date_name"
                              label="日期"
                              v-if="item.array_date !== 'NONE' "
                          >
                          </el-table-column>
                          <el-table-column
                              prop="field_value"
                              label="数值"
                          >
                          </el-table-column>

                        </el-table>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else>
                      <el-form-item :label="item.label"

                      >
                        <el-input :rows="3" v-model="item.field_value" placeholder="" type="textarea"
                                  disabled></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>

              <el-tab-pane label="签到位置" v-if="activeStyle == 2 ? true : false" name="third">
                <div class="amap-page-container" style="height: 300px">
                  <el-amap-search-box
                      :default="searchStr"
                      class="search-box"
                      :search-option="searchOption"
                      :on-search-result="onSearchResult2"
                      style="position: relative;top: 20px;left: 20px"
                  ></el-amap-search-box>
                  <el-amap
                      vid="mapDemo1_3"
                      :center="center2_1"
                      :zoom="12"
                      :plugin="plugin"
                      :amapManager="amapManager"
                      class="amap-demo"
                      style="position: relative;top:-60px;"
                  >
                    <el-amap-marker :position="marker" :draggable="true" :events="edit_markers1.events"
                                    v-for="marker in centers2_1">
                    </el-amap-marker>
                  </el-amap>
                </div>
                <div style="margin-top: 10px" class="amap">
                  <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                    <el-form-item label="名称">

                      <el-input v-model="locationForm.location_name"></el-input>

                    </el-form-item>
                    <el-form-item label="地址">

                      <el-input v-model="locationForm.address"></el-input>

                    </el-form-item>
                  </el-form>
                </div>

              </el-tab-pane>
              <el-tab-pane label="签到位置" v-else name="third">
                <div class="amap-page-container" style="height: 300px">
                  <!--                                    <el-amap-search-box-->
                  <!--                                            :default="searchStr"-->
                  <!--                                            class="search-box"-->
                  <!--                                            :search-option="searchOption"-->
                  <!--                                            :on-search-result="onSearchResult"-->
                  <!--                                            style="position: relative;top: 20px;left: 20px"-->
                  <!--                                    ></el-amap-search-box>-->
                  <el-amap
                      vid="mapDemo1_4"
                      :center="center2"
                      :zoom="12"
                      :plugin="plugin"
                      :amapManager="amapManager"
                      class="amap-demo"
                      style="position: relative;"
                  >
                    <el-amap-marker

                        :position="center.position"
                        :template="center.template"
                        :events="center.events"
                        v-for="center in centers2">
                    </el-amap-marker>
                  </el-amap>
                </div>
                <div style="margin-top: 10px" class="amap">
                  <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                    <el-form-item label="名称">

                      <el-input v-model="locationForm.location_name" disabled></el-input>

                    </el-form-item>
                    <el-form-item label="地址">

                      <el-input v-model="locationForm.address" disabled></el-input>

                    </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col>
            <div :style="{width:'100%',height:'62px',padding:'10px 0px',overflow:'hidden',position:'relative'}">
              <div style="width:20px;height: 20px;position: absolute;top: 32px;left:0px; cursor:pointer;"
                   @click="locationLeftBut">
                <img src="../../assets/images/locationLeft.png" style="width: 20px;height: 20px;">
              </div>
              <div style="width:50px;height: 50px;float: left;margin-top:6px;margin-left: 35px;cursor:pointer;"
                   @click.stop="addLocation" @click="dialog1 = true">
                <img src="../../assets/images/locationAdd.png" style="width: 50px;height: 50px;">
              </div>
              <div style="float:left;height: 62px;width:85%;overflow:hidden">
                <div style=";;height: 62px;position: relative;white-space: nowrap;transition: .3s;"
                     :style="{'left':marginValue +'px' ,'width':widthLocation}"
                >
                  <div
                      :style="{width: '250px',height: '60px',border:'1px solid #ccc',marginLeft: '10px',marginBottom: '10px',backgroundColor:mydiv===j?'#ecf3fc':'#fff',borderColor:mydiv===j?'#4A90E2':'#ededed',}"
                      v-for="(item,j) in locationInfo"
                      @click="InstitutionClient(item,j)" class="mydiv"
                      style="display: inline-block;white-space: nowrap;"
                  >
                    <div style="float: left">
                      <p style="margin:20px 10px;background: #999;color: #fff;border-radius: 50%;width: 20px;height: 20px;text-align: center;line-height: 20px;">
                        {{ j + 1 }}</p>
                    </div>
                    <div style="float: left">
                      <p style="padding: 10px 0px;margin: 0;color: #4A4A4A;font-size: 16px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ item.location_name }}</p>
                      <p style="padding: 0px 0px;margin: 0;color: #B0B5B9;font-size: 14px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ item.address }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div style="width:20px;height: 20px;position: absolute;top: 32px;right:0px; cursor:pointer;"
                   @click="locationRightBut">
                <img src="../../assets/images/locationRight.png" style="width: 20px;height: 20px;">
              </div>
            </div>
          </el-col>
          <el-col>
            <div class="amap-page-container" style="height: 300px">
              <el-amap-search-box
                  :default="searchStr"
                  class="search-box"
                  :search-option="searchOption"
                  :on-search-result="onSearchResult4"
                  style="position: relative;top: 20px;left: 20px;height:35px"
              ></el-amap-search-box>
              <el-amap
                  vid="mapDemo1_5"
                  :center="center4_1"
                  :zoom="12"
                  :plugin="plugin"
                  :amapManager="amapManager"
                  class="amap-demo"
                  style="position: relative;top:-30px;margin: 0"
              >
                <el-amap-marker :position="marker" :visible="true" :draggable="true" :events="edit_markers.events"
                                v-for="marker in markers">
                </el-amap-marker>
              </el-amap>
            </div>
            <div style="margin-top: 30px" class="amap">
              <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                <el-form-item label="名称">

                  <el-input v-model="locationForm.location_name" @input="change1"></el-input>

                </el-form-item>
                <el-form-item label="地址">

                  <el-input v-model="locationForm.address" @input="change2"></el-input>

                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="steps2Click" size="small"
                       style="float: left;margin-top:20px;background: #FF9901;color: #fff;border:none;">上一步
            </el-button>
            <el-button @click="steps3Click" size="small"
                       style="float: right;margin-top:20px;background: #FF9901;color: #fff;border:none;">下一步
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 3 ? 'block' : 'none'}" id="steps3_1">
        <el-row style="margin-top:20px;">
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="调整类型">
                <p style="margin:0; font-size: 16px;color:#7ED321;" v-if="activeStyle == 1 ? true:false">将现有门店移入辖区</p>
                <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="activeStyle == 2 ? true:false">在辖区内添加新的门店</p>
                <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="activeStyle == 3 ? true:false">将现有门店移出辖区</p>
                <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="activeStyle == 4 ? true:false">调整门店的签到位置坐标</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="门店名称">
                <p v-if="activeStyle == 2 ? true:false" style="margin:0;font-size: 16px;color:#4A90E2;">
                  {{ pushStoreList.store_name }}</p>
                <p v-else style="margin:0;font-size: 16px;color:#4A90E2;">{{ basicInfoForm.store_name }}</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-form ref="storeForm" label-width="130px" :model="jurisdictionForm" style="font-size: 14px">
            <!--                        <el-col :span="24">-->
            <!--                            <el-form-item label="生效日期">-->
            <!--                            <el-date-picker-->
            <!--                                    v-model="jurisdictionForm.effective_date"-->
            <!--                                    type="date"-->
            <!--                                    format="yyyy-MM-dd"-->
            <!--                                    value-format="yyyy-MM-dd"-->
            <!--                                    placeholder="选择日期">-->
            <!--                            </el-date-picker>-->
            <!--                                <el-select v-model="jurisdictionForm.effective_date" placeholder="请选择生效日期">-->
            <!--                                    <el-option-->
            <!--                                            v-for="item in effectiveOptions"-->
            <!--                                            :key="item.key"-->
            <!--                                            :label="item.value"-->
            <!--                                            :value="item.key">-->
            <!--                                    </el-option>-->
            <!--                                </el-select>-->
            <!--                            </el-form-item>-->

            <!--                        </el-col>-->
            <el-col :span="24">
              <el-form-item label="推广产品" prop="productArray" >
                <el-select v-model="jurisdictionForm.productArray" style="width: 100%"
                           v-if="activeStyle == 3||activeStyle==4" multiple
                           :disabled="activeStyle == 3||activeStyle==4 ? true: false" placeholder="">
                  <el-option
                      v-for="item in productList1"
                      :key="item.key"
                      :label="item.value1"
                      :value="item.key"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="jurisdictionForm.productArray" style="width: 100%" v-else multiple
                           :disabled="activeStyle == 3 ? true: false" placeholder="请选择推广产品">
                  <el-option
                          v-for="item in territoryProductArray"
                          :key="item.product_id"
                          :label="item.product_name"
                          :value="item.product_id">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="24">
              <el-form-item label="申请理由">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入申请理由"
                    v-model="jurisdictionForm.textarea">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="steps4Click" size="small"
                       style="float: left;margin-top:20px;background: #FF9901;color: #fff;border:none;">上一步
            </el-button>
            <el-button type="primary" @click="steps5Click" size="small" style="float: right;margin-top:20px;">立即提交
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 4 ? 'block' : 'none'}" id="steps4_1">
        <el-row style="margin-top:20px;">
          <el-col :span="24">
            <img src="../../assets/images/applySuccess.png"
                 style="width: 100px;height: 100px;display: block;margin:0 auto;">
            <p style="font-size: 20px;color: #FF9901;text-align: center;margin-top:20px;margin-bottom: 0px;">
              以下申请已成功提交，请等待主管审批</p>
          </el-col>
        </el-row>
        <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 70%;height: 220px;margin:20px auto;">
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="margin-top:10px;height: 40px">
              <el-form-item label="调整类型">
                <p style="margin:0; font-size: 16px;color:#7ED321;" v-if="activeStyle == 1 ? true:false">将现有门店移入辖区</p>
                <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="activeStyle == 2 ? true:false">在辖区内添加新的门店</p>
                <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="activeStyle == 3 ? true:false">将现有门店移出辖区</p>
                <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="activeStyle == 4 ? true:false">调整门店的签到位置坐标</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24" style="height: 40px;">
            <el-form ref="form" label-width="130px" :model="form">
              <el-form-item label="门店名称">
                <p v-if="activeStyle == 2 ? true:false" style="margin:0;font-size: 16px;color:#4A90E2;">
                  {{ pushStoreList.store_name }}</p>
                <p v-else style="margin:0;font-size: 16px;color:#4A90E2;">{{ basicInfoForm.store_name }}</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-form ref="form" label-width="130px" :model="jurisdictionForm" style="font-size: 14px">
            <!--                        <el-col :span="24" style="height: 40px;">-->
            <!--                            <el-form-item label="生效日期">-->
            <!--                                <p  style="margin:0;color: #87909A;">{{jurisdictionForm.effective_date == 'C' ? '本月生效' : '次月生效'}}</p>-->
            <!--                            </el-form-item>-->
            <!--                        </el-col>-->
            <el-col :span="24" style="height: 40px;" v-if="activeStyle==4">
              <el-form-item label="推广产品">
                                <span v-for="(item,j) in jurisdictionForm.productArray" >
                                    <span v-for="(a,b) in productList1" v-if="item == a.key"
                                          style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{
                                        a.value1
                                      }}</span>
                                </span>

              </el-form-item>
            </el-col>

            <el-col :span="24" style="height: 40px;" v-else>
              <el-form-item label="推广产品">
                <span v-for="(item,j) in jurisdictionForm.productArray" >
                                    <span v-for="(a,b) in territoryProductArray" v-if="item == a.product_id"
                                          style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{
                                        a.product_name
                                      }}</span>
                                </span>

              </el-form-item>
            </el-col>
            <el-col :span="24" style="height: 40px;">
              <el-form-item label="申请理由">
                <p style="margin:0;color: #87909A;">{{ jurisdictionForm.textarea }}</p>
              </el-form-item>

            </el-col>
          </el-form>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">

            <el-button type="success" @click.stop="steps6Click" @click="addModelJurisdiction2 = false" size="small"
                       style="float: right;margin-top:20px;">完成
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="addModelJurisdiction3" width="900px" :show-close="false">
      <div slot="title" class="dialog-footer"
           style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
        <span style="color: #3998F7;font-size: 22px">辖区调整申请 </span>
        <span>
<!--                <el-button @click="saveAddInstitutions" type="primary" size="small">保存</el-button>-->
                <el-button type="danger" @click="addModelJurisdiction3 = false" size="small">取消</el-button>
                </span>
      </div>
      <el-steps :active="stepsName" simple finish-status="success">
        <el-step title="选择类型"></el-step>
        <el-step title="填写信息"></el-step>
        <el-step title="提交申请"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <div :style="{display:steps == 1 ? 'block' : 'none',marginTop:'20px',overflow: 'hidden'}">
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_ADD']==='T'" style="width: 80%;margin:0 auto; margin-top:20px;" @click.native="clickActiveStyle(1)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===1?'#ecf3fc':'#fff',borderColor:activeStyle===1?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/jiahao.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #7ED321;margin:20px 0px;">将现有经销商移入辖区</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                将公司主数据中已经存在的经销商移入到我的辖区内</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_ENROLLMENT']==='T'" style="width: 80%;margin:0 auto; margin-top:20px;" @click.native="clickActiveStyle(2)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===2?'#ecf3fc':'#fff',borderColor:activeStyle===2?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/FillAdd.png"
                   style="width: 44px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #FF9901;margin:20px 0px;">在辖区内添加新的经销商</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                提交辖区内新的经销商数据（该经销商在公司主数据中尚不存在）</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_REMOVE']==='T'" style="width: 80%;margin:0 auto;margin-top:20px;" @click.native="clickActiveStyle(3)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===3?'#ecf3fc':'#fff',borderColor:activeStyle===3?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/jianhao.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #ED3B3F;margin:20px 0px;">将现有经销商移出辖区</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                将我的辖区中已经存在的经销商移出</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="systemConfig['ENABLE_TERRITORY_CLIENT_LOCATION']==='T'" style="width: 80%;margin:0 auto;margin-top:20px;"
                @click.native="clickActiveStyle(4)">
          <el-col :span="24" style="height: 100px;border: 1px solid #979797; "
                  :style="{backgroundColor:activeStyle===4?'#ecf3fc':'#fff',borderColor:activeStyle===4?'#4A90E2':'#979797'}">
            <el-col :span="4" style="height: 100%;">
              <img src="../../assets/images/tiaozheng.png"
                   style="width: 50px;height: 50px;margin:0 auto;display: block;margin-top:24px;">
            </el-col>
            <el-col :span="20">
              <p style="font-size: 24px;color: #d68af9;margin:20px 0px;">调整经销商的签到位置坐标</p>
              <p style="font-size: 16px;color: #4A4A4A;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                对辖区中的经销商签到位置进行修正</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px">
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="step1Click" size="small"
                       style="float: right;margin-top:20px;background: #FF9901;color: #fff;border:none;">下一步
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 2 ? 'block' : 'none'}" id="steps2_2">
        <el-row style="margin-top:20px;">
          <el-col :span="24" v-if="activeStyle == 2 ? false : true">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="选择经销商">
                <el-select v-model="distributor_id" @change="getDistributorInfoAction" placeholder="请选择经销商" filterable
                           style="width: 100%" clearable>
                  <el-option
                      v-for="item in distributorForm"
                      :key="item.distributor_id"
                      :label="item.distributor_name"
                      :value="item.distributor_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24" v-if="activeStyle == 2 ? true : false">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="新经销商">
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-if="activeStyle==4?false:true">
          <el-col>
            <el-tabs v-model="activeName1">
              <el-tab-pane label="基本信息" name="first">
                <el-row v-if="activeStyle == 2 ? true : false">
                  <el-form ref="pushDistributorList" :model="pushDistributorList" label-width="130px"
                           style="font-size: 14px;margin-top: 10px;">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="名称" prop="distributor_name"
                                      :rules="[{ required: true, message: '名称不能为空'},]">
                          <el-input v-model="pushDistributorList.distributor_name" placeholder="请输入名称"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="编码" prop="distributor_code"
                                      :rules="[{ required: true, message: '编码不能为空'},]">
                          <el-input v-model="pushDistributorList.distributor_code" placeholder="请输入经销商编码"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="类别" prop="distributor_type"
                                      :rules="[{ required: true, message: '类别不能为空'},]">
                          <el-select v-model="pushDistributorList.distributor_type" placeholder="请选择"
                                     style="width: 100%" @change="fangfa3_1" clearable>
                            <el-option
                                v-for="item in distributorTypeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="级别">
                          <el-select v-model="pushDistributorList.distributor_grade_name" placeholder="请选择"
                                     style="width: 100%" clearable>
                            <el-option
                                v-for="item in distributorGardeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="省份" prop="province_id" :rules="[{ required: true, message: '省份不能为空'},]">
                          <el-select v-model="pushDistributorList.province_id" placeholder="请选择" style="width: 100%"
                                     @change="fangfa3_2" clearable>
                            <el-option
                                v-for="item in data1"
                                :key="item.province_id"
                                :label="item.province_name"
                                :value="item.province_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="城市" prop="city_id" :rules="[{ required: true, message: '城市不能为空'},]">
                          <el-select v-model="pushDistributorList.city_id" placeholder="请选择" style="width: 100%"
                                     clearable>
                            <el-option
                                v-for="item in distributorCityList"
                                :key="item.city_id"
                                :label="item.city_name"
                                :value="item.city_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="地址">
                          <el-input v-model="pushDistributorList.address" placeholder="请输入地址"></el-input>
                        </el-form-item>
                      </el-col>


                      <el-col :span="12">
                        <el-form-item label="联系电话">
                          <el-input v-model="pushDistributorList.telephone" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="邮政编码">
                          <el-input v-model="pushDistributorList.postcode" placeholder="请输入邮政编码"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="官方网址">
                          <el-input v-model="pushDistributorList.website" placeholder="请输入官方网址"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="开发进度">
                          <el-select v-model="pushDistributorList.agreement_stage" placeholder="请选择开发进度"
                                     style="width: 100%">
                            <el-option
                                v-for="item in DISTRIBUTOR_AGREEMENT_STAGE"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="已进药">
                          <el-switch
                              v-model="pushDistributorList.agreement_signed"
                              active-color="#13ce66"
                              active-value="T"
                              inactive-value="F"
                          >
                          </el-switch>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </el-row>
                <el-row v-else>
                  <el-form ref="form" label-width="130px" :model="basicInfoForm"
                           style="font-size: 14px;margin-top: 10px;">
                    <el-col :span="12">
                      <el-form-item label="名称">
                        <el-input v-model="basicInfoForm.distributor_name" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="编码">
                        <el-input v-model="basicInfoForm.distributor_code" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="类别">
                        <el-select v-model="basicInfoForm.distributor_type" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in distributorTypeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="级别">
                        <el-select v-model="basicInfoForm.distributor_grade" placeholder="" disabled
                                   style="width: 100%">
                          <el-option
                              v-for="item in distributorGardeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="省份">
                        <el-select v-model="basicInfoForm.province_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in data1"
                              :key="item.province_id"
                              :label="item.province_name"
                              :value="item.province_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="城市">
                        <el-select v-model="basicInfoForm.city_id" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in CityList1"
                              :key="item.city_id"
                              :label="item.city_name"
                              :value="item.city_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="地址">
                        <el-input v-model="basicInfoForm.address" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话">
                        <el-input v-model="basicInfoForm.telephone" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="邮政编码">
                        <el-input v-model="basicInfoForm.postcode" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="官方网址">
                        <el-input v-model="basicInfoForm.website" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开发进度">
                        <el-select v-model="basicInfoForm.agreement_stage" placeholder="" disabled style="width: 100%">
                          <el-option
                              v-for="item in DISTRIBUTOR_AGREEMENT_STAGE"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="已进药">
                        <el-switch
                            v-model="basicInfoForm.agreement_signed"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            disabled>
                        </el-switch>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </el-tab-pane>
              <el-tab-pane v-if="activeStyle == 2 ? true : false" :label="items.group_name" :name="items.name"
                           v-for="(items,i) in extendedInfo3_2">
                <div class="subjectList" style="margin-top: 20px;">
                  <el-form :ref="'extendedInfo3_2'+i+j" label-width="30%" v-for="(item,j) in items.fieldArray"
                           :model="item" :key="item.field_id">
                    <el-col span="24" v-if="item.input_type == 'TEXT'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input v-model="item.field_value" placeholder="请输入文本"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'DATE'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-date-picker
                            v-model="item.field_value"
                            type="date"
                            placeholder="选择日期时间"
                            style="width: 100%"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :disabled="item.readonly == 'T'">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                      <el-form-item :label="item.label"

                      >
                        <el-switch
                            v-model="item.field_value"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            :disabled="item.readonly == 'T'"
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'LIST'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <!--                                            <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" :disabled="item.readonly == 'T'" clearable>-->
                        <!--                                                <el-option-->
                        <!--                                                        v-for="item in item.listArray"-->
                        <!--                                                        :key="item.value"-->
                        <!--                                                        :label="item.label"-->
                        <!--                                                        :value="item.value">-->
                        <!--                                                </el-option>-->
                        <!--                                            </el-select>-->
                        <el-cascader
                            v-model="item.field_value"
                            :options="item.listArray"
                            style="width: 100%"
                            filterable
                            :show-all-levels="false"
                            :disabled="item.readonly == 'T'"
                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                            clearable></el-cascader>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-table
                            :data="item.field_value"
                            border
                            style="width: 100%">
                          <el-table-column
                              type="index"
                              label="序号"
                              width="50">
                          </el-table-column>
                          <el-table-column
                              prop="dept_name"
                              label="标准科室"
                              v-if="item.array_dept !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="product_name"
                              label="产品"
                              v-if="item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="sku_name"
                              label="SKU"
                              v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="date_name"
                              label="日期"
                              v-if="item.array_date !== 'NONE' "
                          >
                          </el-table-column>
                          <el-table-column
                              prop="field_value"
                              label="数值"
                          >
                          </el-table-column>
                          <el-table-column
                              fixed="right"
                              label="操作"
                              width="80">
                            <template slot-scope="scope">
                              <el-button @click="handleTableClick(scope.$index, scope.row,item)"
                                         style="background-color: rgb(255, 153, 1);border: 1px solid rgb(255, 153, 1);color: #fff"
                                         size="small">详情
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-form-item>
                      <el-col :span="24" style="margin-bottom: 10px;">
                        <el-button size="small" icon="el-icon-plus"
                                   style="float: left;margin-left: 30%;background-color:#6cc584;border: 1px solid #6cc584;color:#fff"
                                   @click="addNewTable(item)">添加新数据
                        </el-button>
                      </el-col>
                      <el-col :span="24" v-if="item.isAddTable" id="addTable3"
                              style="margin-left: 30%;width:70%;background: #edf3fb;border: 1px solid #ecdfe6;margin-bottom:10px;border-radius: 10px;">
                        <el-col :span="14">
                          <el-form ref="addTable1" :model="item.addTableList" style="margin-top:20px">
                            <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id"
                                          :rules="{ required: true, message: '标准科室不能为空'}">
                              <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                                         style="width: 70%;float: right" clearable>
                                <el-option
                                    v-for="item in administrativeList"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="产品" v-if="item.array_product !== 'NONE'" prop="product_id"
                                          :rules="{ required: true, message: '产品不能为空'}">
                              <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                                         style="width: 70%;float: right" @change="getSkuList(item)" clearable>
                                <el-option
                                    v-for="item in productList1"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="SKU"
                                          v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                          prop="sku_id"
                                          :rules="{ required: true, message: 'SKU不能为空'}">
                              <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                                         style="width: 70%;float: right" clearable>
                                <el-option
                                    v-for="item in SkuList"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="日期" v-if="item.array_date !== 'NONE' && item.array_date !== ''"
                                          prop="info_date" :class="{home_star:true}"
                                          :rules="{ required: true, message: '日期不能为空'}">
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="year"
                                  style="width: 70%;float: right"
                                  format="yyyy年"
                                  value-format="yyyy年"
                                  placeholder="选择年"
                                  v-if="item.array_date == 'YEAR'"
                              >
                              </el-date-picker>
                              <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                                       :defaultValue="item.addTableList.info_date" :getValue="getQuarterValue"
                                       style="width: 70%;float: right"></quarter>
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="month"
                                  style="width: 70%;float: right"
                                  format="yyyy年MM月"
                                  value-format="yyyy年MM月"
                                  placeholder="选择月"
                                  v-if="item.array_date == 'MONTH'"
                              >
                              </el-date-picker>
                              <monthComponent v-if="item.array_date == 'WEEK'" @week-event="parentWeekEvent"
                                              :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                                              style="width: 70%;float: right"></monthComponent>
                              <el-date-picker
                                  v-model="item.addTableList.info_date"
                                  type="date"
                                  placeholder="选择日期"
                                  style="width: 70%;float: right"
                                  format="yyyy年MM月dd日"
                                  value-format="yyyy年MM月dd日"
                                  v-if="item.array_date == 'DAY'"
                              >
                              </el-date-picker>
                            </el-form-item>
                            <el-form-item label="数值" prop="field_value"
                                          :rules="{ required: true, message: '数值不能为空'}">
                              <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                                        style="width: 70%;float: right" type="number"></el-input>
                            </el-form-item>
                          </el-form>

                        </el-col>
                        <el-col :span="10">
                          <el-col style="margin-top:20px;">
                            <el-button size="small"
                                       style="float: left;margin-left: 40px;background-color:#588ede;border: 1px solid #588ede;color:#fff"
                                       @click="addTableDataDis(item)">保存
                            </el-button>
                            <el-button
                                style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                @click="delateTableData(item)" v-if="delateFalse" size="small">删除
                            </el-button>
                            <el-button size="small"
                                       style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                       @click="cancelTableData(item)">取消
                            </el-button>
                          </el-col>

                        </el-col>
                      </el-col>
                    </el-col>

                    <el-col span="24" v-else>
                      <el-form-item :label="item.label"
                                    prop="field_value"
                                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                      >
                        <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                                  :disabled="item.readonly == 'T'"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="activeStyle == 1 || activeStyle == 3" :label="items.group_name" :name="items.name"
                           v-for="(items,j) in extendedInfo3">
                <div class="subjectList" style="margin-top: 20px;">
                  <el-form :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item"
                           :key="item.field_id">
                    <el-col span="24" v-if="item.input_type == 'TEXT'">
                      <el-form-item :label="item.label"

                      >
                        <el-input v-model="item.field_value" placeholder="" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                      <el-form-item :label="item.label"

                      >
                        <el-input v-model="item.field_value" placeholder="" type="number" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'DATE'">
                      <el-form-item :label="item.label"

                      >
                        <el-date-picker
                            v-model="item.field_value"
                            type="date"
                            placeholder=""
                            style="width: 100%"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            disabled>
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                      <el-form-item :label="item.label"

                      >
                        <el-switch
                            v-model="item.field_value"
                            active-color="#13ce66"
                            active-value="T"
                            inactive-value="F"
                            disabled
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col span="24" v-else-if="item.input_type == 'LIST'">
                      <el-form-item :label="item.label"

                      >
                        <el-cascader
                            v-model="item.field_value"
                            :options="item.listArray"
                            style="width: 100%"
                            filterable
                            disabled
                            placeholder=""
                            :show-all-levels="false"
                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                            clearable></el-cascader>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                      <el-form-item :label="item.label"

                      >
                        <el-table
                            :data="item.field_value"
                            border
                            style="width: 100%">
                          <el-table-column
                              type="index"
                              label="序号"
                              width="50">
                          </el-table-column>
                          <el-table-column
                              prop="dept_name"
                              label="标准科室"
                              v-if="item.array_dept !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="product_name"
                              label="产品"
                              v-if="item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="sku_name"
                              label="SKU"
                              v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                          >
                          </el-table-column>
                          <el-table-column
                              prop="date_name"
                              label="日期"
                              v-if="item.array_date !== 'NONE' "
                          >
                          </el-table-column>
                          <el-table-column
                              prop="field_value"
                              label="数值"
                          >
                          </el-table-column>

                        </el-table>
                      </el-form-item>
                    </el-col>

                    <el-col span="24" v-else>
                      <el-form-item :label="item.label"

                      >
                        <el-input :rows="3" v-model="item.field_value" placeholder="" type="textarea"
                                  disabled></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>

              <el-tab-pane label="签到位置" v-if="activeStyle == 2 ? true : false" name="third">
                <div class="amap-page-container" style="height: 300px">
                  <el-amap-search-box
                      :default="searchStr"
                      class="search-box"
                      :search-option="searchOption"
                      :on-search-result="onSearchResult3"
                      style="position: relative;top: 20px;left: 20px"
                  ></el-amap-search-box>
                  <el-amap
                      vid="mapDemo1_6"
                      :center="center3_1"
                      :zoom="12"
                      :plugin="plugin"
                      :amapManager="amapManager"
                      class="amap-demo"
                      style="position: relative;top:-60px;"
                  >
                    <el-amap-marker :position="marker" :draggable="true" :events="edit_markers1.events"
                                    v-for="marker in centers3_1">
                    </el-amap-marker>
                  </el-amap>
                </div>
                <div style="margin-top: 10px" class="amap">
                  <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                    <el-form-item label="名称">

                      <el-input v-model="locationForm.location_name"></el-input>

                    </el-form-item>
                    <el-form-item label="地址">

                      <el-input v-model="locationForm.address"></el-input>

                    </el-form-item>
                  </el-form>
                </div>

              </el-tab-pane>
              <el-tab-pane label="签到位置" v-else name="third">
                <div class="amap-page-container" style="height: 300px">
                  <!--                                    <el-amap-search-box-->
                  <!--                                            :default="searchStr"-->
                  <!--                                            class="search-box"-->
                  <!--                                            :search-option="searchOption"-->
                  <!--                                            :on-search-result="onSearchResult"-->
                  <!--                                            style="position: relative;top: 20px;left: 20px"-->
                  <!--                                    ></el-amap-search-box>-->
                  <el-amap
                      vid="mapDemo1_7"
                      :center="center3"
                      :zoom="12"
                      :plugin="plugin"
                      :amapManager="amapManager"
                      class="amap-demo"
                      style="position: relative;"
                  >
                    <el-amap-marker

                        :position="center.position"
                        :template="center.template"
                        :events="center.events"
                        v-for="center in centers3">
                    </el-amap-marker>
                  </el-amap>
                </div>
                <div style="margin-top: 10px" class="amap">
                  <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                    <el-form-item label="名称">

                      <el-input v-model="locationForm.location_name" disabled></el-input>

                    </el-form-item>
                    <el-form-item label="地址">

                      <el-input v-model="locationForm.address" disabled></el-input>

                    </el-form-item>
                  </el-form>
                </div>

              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col>
            <div :style="{width:'100%',height:'62px',padding:'10px 0px',overflow:'hidden',position:'relative'}">
              <div style="width:20px;height: 20px;position: absolute;top: 32px;left:0px; cursor:pointer;"
                   @click="locationLeftBut">
                <img src="../../assets/images/locationLeft.png" style="width: 20px;height: 20px;">
              </div>
              <div style="width:50px;height: 50px;float: left;margin-top:6px;margin-left: 35px;cursor:pointer;"
                   @click.stop="addLocation" @click="dialog1 = true">
                <img src="../../assets/images/locationAdd.png" style="width: 50px;height: 50px;">
              </div>
              <div style="float:left;height: 62px;width:85%;overflow:hidden">
                <div style=";;height: 62px;position: relative;white-space: nowrap;transition: .3s;"
                     :style="{'left':marginValue +'px' ,'width':widthLocation}"
                >
                  <div
                      :style="{width: '250px',height: '60px',border:'1px solid #ccc',marginLeft: '10px',marginBottom: '10px',backgroundColor:mydiv===j?'#ecf3fc':'#fff',borderColor:mydiv===j?'#4A90E2':'#ededed',}"
                      v-for="(item,j) in locationInfo"
                      @click="InstitutionClient(item,j)" class="mydiv"
                      style="display: inline-block;white-space: nowrap;"
                  >
                    <div style="float: left">
                      <p style="margin:20px 10px;background: #999;color: #fff;border-radius: 50%;width: 20px;height: 20px;text-align: center;line-height: 20px;">
                        {{ j + 1 }}</p>
                    </div>
                    <div style="float: left">
                      <p style="padding: 10px 0px;margin: 0;color: #4A4A4A;font-size: 16px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ item.location_name }}</p>
                      <p style="padding: 0px 0px;margin: 0;color: #B0B5B9;font-size: 14px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        {{ item.address }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div style="width:20px;height: 20px;position: absolute;top: 32px;right:0px; cursor:pointer;"
                   @click="locationRightBut">
                <img src="../../assets/images/locationRight.png" style="width: 20px;height: 20px;">
              </div>
            </div>
          </el-col>
          <el-col>
            <div class="amap-page-container" style="height: 300px" id="">
              <el-amap-search-box
                  :default="searchStr"
                  class="search-box"
                  :search-option="searchOption"
                  :on-search-result="onSearchResult4"
                  style="position: relative;top: 20px;left: 20px;height:35px"
              ></el-amap-search-box>
              <el-amap
                  vid="mapDemo1_8"
                  :center="center4_1"
                  :zoom="12"
                  :plugin="plugin"
                  :amapManager="amapManager"
                  class="amap-demo"
                  style="position: relative;top:-30px;margin: 0"
              >
                <el-amap-marker :position="marker" :visible="true" :draggable="true" :events="edit_markers.events"
                                v-for="marker in markers">
                </el-amap-marker>
              </el-amap>
            </div>
            <div style="margin-top: 30px" class="amap">
              <el-form ref="formapLocation" :model="locationForm" label-width="80px">
                <el-form-item label="名称">

                  <el-input v-model="locationForm.location_name" @input="change1"></el-input>

                </el-form-item>
                <el-form-item label="地址">

                  <el-input v-model="locationForm.address" @input="change2"></el-input>

                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="steps2Click" size="small"
                       style="float: left;margin-top:20px;background: #FF9901;color: #fff;border:none;">上一步
            </el-button>
            <el-button @click="steps3Click" size="small"
                       style="float: right;margin-top:20px;background: #FF9901;color: #fff;border:none;">下一步
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 3 ? 'block' : 'none'}" id="steps3_2">
        <el-row style="margin-top:20px;">
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="调整类型">
                <p style="margin:0; font-size: 16px;color:#7ED321;" v-if="activeStyle == 1 ? true:false">将现有经销商移入辖区</p>
                <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="activeStyle == 2 ? true:false">在辖区内添加新的经销商</p>
                <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="activeStyle == 3 ? true:false">将现有经销商移出辖区</p>
                <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="activeStyle == 4 ? true:false">
                  调整经销商的签到位置坐标</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="font-size: 14px">
              <el-form-item label="经销商名称">
                <p v-if="activeStyle == 2 ? true:false" style="margin:0;font-size: 16px;color:#4A90E2;">
                  {{ pushDistributorList.distributor_name }}</p>
                <p v-else style="margin:0;font-size: 16px;color:#4A90E2;">{{ basicInfoForm.distributor_name }}</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-form ref="distributorForm" label-width="130px" :model="jurisdictionForm" style="font-size: 14px">
            <!--                        <el-col :span="24">-->
            <!--                            <el-form-item label="生效日期">-->
            <!--                                <el-select v-model="jurisdictionForm.effective_date" placeholder="请选择生效日期">-->
            <!--                                    <el-option-->
            <!--                                            v-for="item in effectiveOptions"-->
            <!--                                            :key="item.key"-->
            <!--                                            :label="item.value"-->
            <!--                                            :value="item.key">-->
            <!--                                    </el-option>-->
            <!--                                </el-select>-->
            <!--                            </el-form-item>-->

            <!--                        </el-col>-->
            <el-col :span="24">
              <el-form-item label="推广产品" prop="productArray">
                <el-select v-model="jurisdictionForm.productArray" style="width: 100%"
                           v-if="activeStyle == 3||activeStyle==4 " multiple
                           :disabled="activeStyle == 3||activeStyle==4 ? true: false" placeholder="">
                  <el-option
                      v-for="item in productList1"
                      :key="item.key"
                      :label="item.value1"
                      :value="item.key"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="jurisdictionForm.productArray" style="width: 100%" v-else multiple
                           :disabled="activeStyle == 3 ? true: false" :placeholder="activeStyle == 3 ? '' : '请选择推广产品'">
                  <el-option
                          v-for="item in territoryProductArray"
                          :key="item.product_id"
                          :label="item.product_name"
                          :value="item.product_id">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="24">
              <el-form-item label="申请理由">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入申请理由"
                    v-model="jurisdictionForm.textarea">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">
            <el-button @click="steps4Click" size="small"
                       style="float: left;margin-top:20px;background: #FF9901;color: #fff;border:none;">上一步
            </el-button>
            <el-button type="primary" @click="steps5Click" size="small" style="float: right;margin-top:20px;">立即提交
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div :style="{display:steps == 4 ? 'block' : 'none'}" id="steps4_2">
        <el-row style="margin-top:20px;">
          <el-col :span="24">
            <img src="../../assets/images/applySuccess.png"
                 style="width: 100px;height: 100px;display: block;margin:0 auto;">
            <p style="font-size: 20px;color: #FF9901;text-align: center;margin-top:20px;margin-bottom: 0px;">
              以下申请已成功提交，请等待主管审批</p>
          </el-col>
        </el-row>
        <el-row style="border: 1px solid #DCDFE6;background: #EEF2F6;width: 70%;height: 220px;margin:20px auto;">
          <el-col :span="24">
            <el-form ref="form" label-width="130px" :model="form" style="margin-top:10px;height: 40px">
              <el-form-item label="调整类型">
                <p style="margin:0; font-size: 16px;color:#7ED321;" v-if="activeStyle == 1 ? true:false">将现有经销商移入辖区</p>
                <p style="margin:0; font-size: 16px;color:#FF9901;" v-if="activeStyle == 2 ? true:false">在辖区内添加新的经销商</p>
                <p style="margin:0; font-size: 16px;color:#ED3B3F;" v-if="activeStyle == 3 ? true:false">将现有经销商移出辖区</p>
                <p style="margin:0; font-size: 16px;color:#d68af9;" v-if="activeStyle == 4 ? true:false">
                  调整经销商的签到位置坐标</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24" style="height: 40px;">
            <el-form ref="form" label-width="130px" :model="form">
              <el-form-item label="经销商名称">
                <p v-if="activeStyle == 2 ? true:false" style="margin:0;font-size: 16px;color:#4A90E2;">
                  {{ pushDistributorList.distributor_name }}</p>
                <p v-else style="margin:0;font-size: 16px;color:#4A90E2;">{{ basicInfoForm.distributor_name }}</p>
              </el-form-item>
            </el-form>
          </el-col>
          <el-form ref="form" label-width="130px" :model="jurisdictionForm" style="font-size: 14px">
            <!--                        <el-col :span="24" style="height: 40px;">-->
            <!--                            <el-form-item label="生效日期">-->
            <!--                                <p style="margin:0;color: #87909A;">{{jurisdictionForm.effective_date == 'C' ? '本月生效' : '次月生效'}}</p>-->
            <!--                            </el-form-item>-->
            <!--                        </el-col>-->
            <el-col :span="24" style="height: 40px;" v-if="activeStyle==4">
              <el-form-item label="推广产品" >
                                <span v-for="(item,j) in jurisdictionForm.productArray" >
                                    <span v-for="(a,b) in productList1" v-if="item == a.key"
                                          style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{
                                        a.value1
                                      }}</span>
                                </span>


              </el-form-item>
            </el-col>

            <el-col :span="24" style="height: 40px;" v-else>
              <el-form-item label="推广产品" >

                <span v-for="(item,j) in jurisdictionForm.productArray" >
                                    <span v-for="(a,b) in territoryProductArray" v-if="item == a.product_id"
                                          style="margin:0;background: #FF9901;color: #fff;border-radius: 5px;padding: 0 10px;margin-right: 10px;">{{
                                        a.product_name
                                      }}</span>
                                </span>

              </el-form-item>
            </el-col>
            <el-col :span="24" style="height: 40px;">
              <el-form-item label="申请理由">
                <p style="margin:0;color: #87909A;">{{ jurisdictionForm.textarea }}</p>
              </el-form-item>

            </el-col>
          </el-form>
        </el-row>
        <el-row>
          <el-col style="border-top: 2px dashed rgb(231, 234, 236);">

            <el-button type="success" @click.stop="steps6Click" @click="addModelJurisdiction3 = false" size="small"
                       style="float: right;margin-top:20px;">完成
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>


    <el-dialog title="" :visible.sync="modelInstitutions" :show-close="false">
      <div slot="title" class="dialog-footer"
           style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
        <span style="color: #3998F7;font-size: 22px">机构详情</span>
        <span>
                <el-button @click="updateInstitutions" v-if="isShowButton()" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="modelInstitutions = false" size="small">关闭</el-button>
                </span>
      </div>
      <el-form class="formSave" :model="formInstiturions" style="width: 80%;margin: auto" label-position="left">
        <el-form-item label="所属辖区" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7;" :push="3">
              {{ formInstiturions.territory_name }}&nbsp;&nbsp;({{ formInstiturions.territory_code }})
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="机构名称" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7;" :push="3">
              {{ formInstiturions.institution_name }}
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="推广产品" label-width="100px">
          <el-row>
            <el-col :span="21" :push="3">
              <el-select @emove-tag="emoveTag" style="width: 100%"
                         :disabled="!isShowButton()"
                         v-model="formInstiturions.productArray"
                         multiple
                         placeholder="请选择"
                         @change="">
                <el-option
                    v-for="item in addProductArray"
                    :key="item"
                    :label="item.product_name"
                    :value="item.product_id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>

        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="" :visible.sync="modelRetailstoreList" :show-close="false">
      <div slot="title" class="dialog-footer"
           style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
        <span style="color: #3998F7;font-size: 22px">门店详情</span>
        <span>
                <el-button @click="updateRetailstoreList" v-if="isShowButton()" type="primary"
                           size="small">保存</el-button>
                <el-button type="danger" @click="modelRetailstoreList = false" size="small">关闭</el-button>
                </span>
      </div>
      <el-form class="formSave" :model="formRetailstoreList" style="width: 80%;margin: auto" label-position="left">
        <el-form-item label="所属辖区" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7;" :push="3">
              {{ formRetailstoreList.territory_name }}&nbsp;&nbsp;({{ formRetailstoreList.territory_code }})
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="门店名称" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7;" :push="3">
              {{ formRetailstoreList.store_name }}
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="推广产品" label-width="100px">
          <el-row>
            <el-col :span="21" :push="3">
              <el-select @emove-tag="emoveTag" style="width: 100%"
                         v-model="formRetailstoreList.productArray"
                         :disabled="!isShowButton()"
                         multiple
                         placeholder="请选择"
                         @change="">
                <el-option
                    v-for="item in addProductArray"
                    :key="item"
                    :label="item.product_name"
                    :value="item.product_id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>

        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="" :visible.sync="modelDistributorList" :show-close="false">
      <div slot="title" class="dialog-footer"
           style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
        <span style="color: #3998F7;font-size: 22px">经销商详情</span>
        <span>
                <el-button @click="updateDistributorList" v-if="isShowButton()" type="primary"
                           size="small">保存</el-button>
                <el-button type="danger" @click="modelDistributorList = false" size="small">关闭</el-button>
                </span>
      </div>
      <el-form class="formSave" :model="formDistributorList" style="width: 80%;margin: auto" label-position="left">
        <el-form-item label="所属辖区" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7;" :push="3">
              {{ formDistributorList.territory_name }}&nbsp;&nbsp;({{ formDistributorList.territory_code }})
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="经销商名称" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7;" :push="3">
              {{ formDistributorList.distributor_name }}
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="推广产品" label-width="100px">
          <el-row>
            <el-col :span="21" :push="3">
              <el-select @emove-tag="emoveTag" style="width: 100%"
                         v-model="formDistributorList.productArray"
                         :disabled="!isShowButton()"
                         multiple
                         placeholder="请选择"
                         @change="">
                <el-option
                    v-for="item in addProductArray"
                    :key="item"
                    :label="item.product_name"
                    :value="item.product_id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>

        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import http from '../../APIService/http'
import quarter from '../../components/quarter'
import monthComponent from '../../components/monthComponent'
import {bus} from "../../router";
import businessBar from "../../components/businessBar";
import inventory from "../calendar/components/components/inventory";
import addTodoList from "../calendar/components/components/addTodoList";
import {Message} from "element-ui";
import {AMapManager} from "vue-amap";
import imgUrl from "../../assets/images/mark_0.png";

let amapManager = new AMapManager();
export default {
  name: "institutionsTow",
  data() {
    let self = this
    return {
      systemConfig: {
        'ENABLE_TERRITORY_CLIENT_ADD': 'F',
        'ENABLE_TERRITORY_CLIENT_REMOVE': 'F',
        'ENABLE_TERRITORY_CLIENT_ENROLLMENT': 'F',
        'ENABLE_TERRITORY_CLIENT_LOCATION': 'F'
      },
      addTableList: {},
      delateFalse: false,
      onoffmap: false,
      amapManager,
      distributorCityList: [],
      distributorTypeList: [],
      storeCityList: [],
      storeTypeList: [],
      edit_markers1:
          {
            position: [],
            events: {
              dragend: (e) => {//拖拽结束

                this.getpois([e.lnglat.lng, e.lnglat.lat])
                let geocoder
                AMap.plugin("AMap.Geocoder", function () {
                  // 这里通过高德 SDK 完成。
                  geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all"
                  });
                })


                geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function (status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    if (result && result.regeocode) {

                      self.locationForm.address = result.regeocode.formattedAddress;    //获取到位置
                      self.locationForm.location_name = result.regeocode.pois[0].name;    //获取到位置

                    }
                  }
                });
              }
            },
            visible: true,

          },
      edit_markers:
          {
            position: [],
            events: {
              dragend: (e) => {//拖拽结束

                this.getpois([e.lnglat.lng, e.lnglat.lat])
                let geocoder
                AMap.plugin("AMap.Geocoder", function () {
                  // 这里通过高德 SDK 完成。
                  geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all"
                  });
                })
                geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function (status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    if (result && result.regeocode) {
                      self.locationForm.address = result.regeocode.formattedAddress
                      self.locationForm.location_name = result.regeocode.pois[0].name
                      self.locationInfo[self.mydiv].address = result.regeocode.formattedAddress
                      self.locationInfo[self.mydiv].location_name = result.regeocode.pois[0].name
                      self.locationInfo[self.mydiv].lng = result.regeocode.pois[0].location.lng
                      self.locationInfo[self.mydiv].lat = result.regeocode.pois[0].location.lat
                      //self.markers.splice(0,1,[self.locationInfo[self.mydiv].lng,self.locationInfo[self.mydiv].lat])
                    }
                  }
                });
              }
            },
          },
      addBasicInfoForm: {
        address: "",
        city_id: "",
        city_name: "",
        comments: "",
        institution_code: '',
        institution_grade: "",
        institution_grade_name: "",
        institution_id: "",
        institution_name: "",
        institution_type: "",
        institution_type_name: "",
        distributor_id: '',
        lat: 0,
        lng: 0,
        location_id: "",
        postcode: "",
        province_id: "",
        province_name: "",
        status: 'ACTIVE',
        telephone: "",
        website: "",
        agreement_stage: '',
        agreement_signed: 'F',
      },
      pushStoreList: {
        address: "",
        city_id: "",
        city_name: "",
        comments: "",
        lat: 0,
        lng: 0,
        location_id: "",
        postcode: "",
        province_id: "",
        province_name: "",
        retailstore_grade: "",
        retailstore_grade_name: "",
        status: 'ACTIVE',
        store_id: "",
        store_name: "",
        store_type: "",
        store_type_name: "",
        telephone: "",
        tenant_id: "",
        website: "",
        distributor_id: '',
        institution_id: '',
        agreement_signed: 'F',
        agreement_stage: ''

      },
      pushDistributorList: {
        address: "",
        city_id: "",
        city_name: "",
        comments: "",
        distributor_grade: "",
        distributor_grade_name: "",
        distributor_id: "",
        distributor_name: "",
        distributor_type: "",
        distributor_type_name: "",
        lat: 0,
        lng: 0,
        location_id: "",
        postcode: "",
        province_id: "",
        province_name: "",
        telephone: "",
        tenant_id: "",
        website: "",
        status: 'ACTIVE',
        distributor_code: '',
        agreement_signed: 'F',
        agreement_stage: ''
      },
      distributorGardeList: [],
      distributor_id: '',
      distributorForm: [],
      storeGardeList: [],
      institutionList: [],
      storeForm: [],
      store_id: '',
      effectiveOptions: [
        {
          key: 'C',
          value: '本月生效'
        },
        {
          key: 'D',
          value: '次月生效'
        },
      ],
      data: {},
      textarea: '',
      productList: [],
      jurisdictionForm: {
        effective_date: 'D',
        productArray: [],
        textarea: ''
      },

      locationForm: {
        location_name: '',
        address: ''
      },
      center: [116.46, 39.92],
      centers: [],
      center1_1: [116.46, 39.92],
      centers1_1: [],
      center2: [116.46, 39.92],
      centers2: [],
      center2_1: [116.46, 39.92],
      centers2_1: [],
      center3: [116.46, 39.92],
      centers3: [],
      center3_1: [116.46, 39.92],
      centers3_1: [],
      center4_1: [116.46, 39.92],
      markers: [],
      addCenter: [116.46, 39.92],
      addCenters: {
        position: [],
      },
      extendedInfo: [],
      extendedInfo1_2: [],
      extendedInfo2: [],
      extendedInfo2_2: [],
      extendedInfo3: [],
      extendedInfo3_2: [],
      distributorList: [],
      data1: [],
      GardeList: [],
      GardeList1: [],
      CityList1: [],
      CityList: [],
      TypeList: [],
      basicInfoForm: {},
      province_id: '',
      institutionsForm: [],
      institution_id: '',
      markers2: [],
      plugin: [{
        pName: 'ToolBar',
        position: 'RB',
        locate: false,

        events: {
          init(instance) {

          }
        }

      }],
      mapCenter: [121.59996, 31.197646],
      searchOption: {
        city: '上海',
        citylimit: false
      },
      searchStr: "",
      activeName: '',
      activeName1: 'first',
      steps: 1,
      activeStyle: 1,
      stepsName: 0,
      addModelJurisdiction: false,
      addModelJurisdiction2: false,
      addModelJurisdiction3: false,
      sname: '',
      snamestore: '',
      snameDistributorList: '',
      loading: true,
      modelInstitutions: false,
      modelRetailstoreList: false,
      modelDistributorList: false,
      addModelDistributorList: false,
      form: {},
      tableInstutionsList: [],
      tableRetailstoreList: [],
      tableDistributorList: [],
      tableInstutionsListLength: 0,
      tableRetailstoreListLength: 0,
      tableDistributorListLength: 0,
      product_num: 0,
      formInstiturions: {
        productArray: [],
        territory_name: '',
        territory_code: '',
        institution_name: '',
        institution_id: '',
        territory_id: '',
        productArraySelect: []
      },
      formRetailstoreList: {
        productArray: [],
        territory_name: '',
        territory_code: '',
        institution_name: '',
        institution_id: '',
        territory_id: '',
        productArraySelect: []
      },
      formDistributorList: {
        productArray: [],
        territory_name: '',
        territory_code: '',
        institution_name: '',
        institution_id: '',
        territory_id: '',
        productArraySelect: []
      },
      addModelInstitutions: false,
      addModelStore: false,
      addFormInstiturions: {
        productArray: [],
        territory_name: '',
        territory_code: '',
        institution_name: '',
        territory_id: '',
        institution_id: ''
      },
      addFormStore: {
        productArray: [],
        territory_name: '',
        territory_code: '',
        store_name: '',
        territory_id: '',
        store_id: ''
      },
      addFormDistributorList: {
        productArray: [],
        territory_name: '',
        territory_code: '',
        distributor_name: '',
        territory_id: '',
        distributor_id: ''
      },
      addProductArray: [],
      medicalName: true,
      retailName: false,
      distributionName: false,
      class_active: true,
      whether_text: 'mymanagement',
      cityList: [],
      casccader_ter: {
        checkStrictly: false,
        value: "id",
        label: "label",
        disabled: "disabled",
        emitPath: false
      },
      institution_list: [],
      store_list: [],
      distributor_list: [],
      uuid: '',
      INSTITUTION_AGREEMENT_STAGE: [],
      RETAILSTORE_AGREEMENT_STAGE: [],
      DISTRIBUTOR_AGREEMENT_STAGE: [],
      locationInfo: [],
      mydiv: 0,
      marginValue: '',
      widthLocation: '',
      administrativeList: [],
      productList1: [],
      territoryProductArray: [],
      SkuList: [],
      showLocation: true,
      changeIns: false,
      clientObj: {},
    }
  },
  watch: {
    $route(to, from) {
      // console.log(this.$route.params.data,56)
      this.data = JSON.parse(this.$route)
      this.getPeople()
    }
  },
  components: {
    quarter,
    monthComponent
  },
  methods: {
    getAdministrativeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: 'STANDARD_DEPT'
      }
      http.post('/wapi/Institution/getAdministrativeList', data).then(res => {
        if (res.success) {
          this.administrativeList = res.data
        }
      })

    },
    getProductList1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      http.post('/wapi/Institution/getProductList', data).then(res => {
        if (res.success) {
          this.productList1 = res.data
        }
      })

    },
    getterritoryProductList() {
      try {
        let data={}
        data.tenant_id= this.$store.getters.getUser.tenant_id
        data.territory_id= this.data.territory_id
         http.post('/wapi/JurActive/getterritoryProductList',data).then(res=>{
          // console.log(res)
          if (res.success === true){
            this.territoryProductArray = res.data
          }
        })
      }catch (e) {

      }

    },
    getSkuList(item) {
      let product_id = ''
      if (item instanceof Object) {
        product_id = item.addTableList.product_id
        item.addTableList.sku_id = ''
        item.addTableList.sku_name = ''
      } else {
        product_id = item
      }

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        product_id: product_id
      }
      http.post('/wapi/Institution/getSkuList', data).then(res => {
        if (res.success) {
          this.SkuList = res.data
        }
      })

    },
    changeQUARTER(item) {
      this.QUARTER = ''
      var arr = item.split('-')
      if (arr[1] < 4) {
        this.QUARTER = arr[0] + 'Q1'
      } else if (arr[1] > 3 && arr[1] < 7) {
        this.QUARTER = arr[0] + 'Q2'
      } else if (arr[1] > 6 && arr[1] < 9) {
        this.QUARTER = arr[0] + 'Q3'
      } else {
        this.QUARTER = arr[0] + 'Q4'
      }

      console.log(item, this.QUARTER)

    },
    changeWEEK(item) {
      this.WEEK = ''
      var arr = item.split('-')
      if (arr[2] < 8) {
        this.WEEK = arr[0] + arr[1] + 'W1'
      } else if (arr[2] > 7 && arr[2] < 15) {
        this.WEEK = arr[0] + arr[1] + 'W2'
      } else if (arr[2] > 14 && arr[2] < 22) {
        this.WEEK = arr[0] + arr[1] + 'W3'
      } else {
        this.WEEK = arr[0] + arr[1] + 'W4'
      }
      console.log(item, this.WEEK)
    },
    getUuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid

    },
    addNewTable(item) {
      this.delateFalse = false
      item.isAddTable = true
      item.addTableList = {
        id: '',
        dept_id: '',
        dept_name: '',
        product_id: '',
        product_name: '',
        sku_id: '',
        sku_name: '',
        info_date: '',
        date_name: '',
        field_value: ''
      }
      this.addTableList = {}
      this.addTableList = item.addTableList
      this.$forceUpdate()
    },
    delateTableData(item) {
      for (let i = 0; i < item.field_value.length; i++) {
        if (item.addTableList.id == item.field_value[i].id) {
          item.field_value.splice(i, 1)
          item.isAddTable = false
          this.$forceUpdate()
        }
      }
    },

    addTableDataIns(item) {

      this.$refs["addTable1"][0].validate(valid => {
        if (!valid) {
          return false
        } else {

          if (this.QUARTER) {
            item.addTableList.info_date = this.QUARTER
            let arr = this.QUARTER.split('Q')
            let year = arr[0].slice(0, 4)
            item.addTableList.date_name = `${year}年第${arr[1]}季度`
          }
          if (this.WEEK) {
            item.addTableList.info_date = this.WEEK
            let arr = this.WEEK.split('W')
            let year = arr[0].slice(0, 4)
            let month = arr[0].slice(4)
            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

          }

          if (item.addTableList.id) {//编辑
            for (let i = 0; i < item.field_value.length; i++) {
              if (item.addTableList.id == item.field_value[i].id) {
                item.field_value[i].dept_id = item.addTableList.dept_id
                if (item.addTableList.dept_id) {
                  for (let j = 0; j < this.administrativeList.length; j++) {
                    if (item.addTableList.dept_id == this.administrativeList[j].key) {
                      item.addTableList.dept_name = this.administrativeList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].dept_name = item.addTableList.dept_name
                item.field_value[i].product_id = item.addTableList.product_id
                if (item.addTableList.product_id) {
                  for (let j = 0; j < this.productList.length; j++) {
                    if (item.addTableList.product_id == this.productList[j].key) {
                      item.addTableList.product_name = this.productList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].product_name = item.addTableList.product_name
                item.field_value[i].sku_id = item.addTableList.sku_id
                if (item.addTableList.sku_id) {
                  for (let j = 0; j < this.SkuList.length; j++) {
                    if (item.addTableList.sku_id == this.SkuList[j].key) {
                      item.addTableList.sku_name = this.SkuList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].sku_name = item.addTableList.sku_name
                item.field_value[i].info_date = item.addTableList.info_date
                item.field_value[i].date_name = item.addTableList.date_name
                item.field_value[i].field_value = item.addTableList.field_value
              }
            }
          } else {//新增
            item.addTableList.id = this.getUuid()
            if (item.addTableList.dept_id) {
              for (let i = 0; i < this.administrativeList.length; i++) {
                if (item.addTableList.dept_id == this.administrativeList[i].key) {
                  item.addTableList.dept_name = this.administrativeList[i].value1
                }
              }
            }
            if (item.addTableList.product_id) {
              for (let i = 0; i < this.productList.length; i++) {
                if (item.addTableList.product_id == this.productList[i].key) {
                  item.addTableList.product_name = this.productList[i].value1
                }
              }
            }
            if (item.addTableList.sku_id) {
              for (let i = 0; i < this.SkuList.length; i++) {
                if (item.addTableList.sku_id == this.SkuList[i].key) {
                  item.addTableList.sku_name = this.SkuList[i].value1
                }
              }
            }
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER
              let arr = this.QUARTER.split('Q')
              let year = arr[0].slice(0, 4)
              item.addTableList.date_name = `${year}年第${arr[1]}季度`
            } else if (this.WEEK) {
              item.addTableList.info_date = this.WEEK
              let arr = this.WEEK.split('W')
              let year = arr[0].slice(0, 4)
              let month = arr[0].slice(4)
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

            } else {
              item.addTableList.date_name = item.addTableList.info_date
            }
            item.field_value.push(item.addTableList)
          }


          item.isAddTable = false
          item.addTableList = {
            id: '',
            dept_id: '',
            dept_name: '',
            product_id: '',
            product_name: '',
            sku_id: '',
            sku_name: '',
            info_date: '',
            date_name: '',
            field_value: ''
          }
          this.$forceUpdate()


        }
      })

    },

    addTableDataStore(item) {

      this.$refs["addTableHcp"][0].validate(valid => {
        if (!valid) {
          return false
        } else {



          if (this.QUARTER) {
            item.addTableList.info_date = this.QUARTER
            let arr = this.QUARTER.split('Q')
            let year = arr[0].slice(0, 4)
            item.addTableList.date_name = `${year}年第${arr[1]}季度`
          }
          if (this.WEEK) {
            item.addTableList.info_date = this.WEEK
            let arr = this.WEEK.split('W')
            let year = arr[0].slice(0, 4)
            let month = arr[0].slice(4)
            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

          }

          if (item.addTableList.id) {//编辑
            for (let i = 0; i < item.field_value.length; i++) {
              if (item.addTableList.id == item.field_value[i].id) {
                item.field_value[i].dept_id = item.addTableList.dept_id
                if (item.addTableList.dept_id) {
                  for (let j = 0; j < this.administrativeList.length; j++) {
                    if (item.addTableList.dept_id == this.administrativeList[j].key) {
                      item.addTableList.dept_name = this.administrativeList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].dept_name = item.addTableList.dept_name
                item.field_value[i].product_id = item.addTableList.product_id
                if (item.addTableList.product_id) {
                  for (let j = 0; j < this.productList.length; j++) {
                    if (item.addTableList.product_id == this.productList[j].key) {
                      item.addTableList.product_name = this.productList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].product_name = item.addTableList.product_name
                item.field_value[i].sku_id = item.addTableList.sku_id
                if (item.addTableList.sku_id) {
                  for (let j = 0; j < this.SkuList.length; j++) {
                    if (item.addTableList.sku_id == this.SkuList[j].key) {
                      item.addTableList.sku_name = this.SkuList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].sku_name = item.addTableList.sku_name
                item.field_value[i].info_date = item.addTableList.info_date
                item.field_value[i].date_name = item.addTableList.date_name
                item.field_value[i].field_value = item.addTableList.field_value
              }
            }
          } else {//新增
            item.addTableList.id = this.getUuid()
            if (item.addTableList.dept_id) {
              for (let i = 0; i < this.administrativeList.length; i++) {
                if (item.addTableList.dept_id == this.administrativeList[i].key) {
                  item.addTableList.dept_name = this.administrativeList[i].value1
                }
              }
            }
            if (item.addTableList.product_id) {
              for (let i = 0; i < this.productList.length; i++) {
                if (item.addTableList.product_id == this.productList[i].key) {
                  item.addTableList.product_name = this.productList[i].value1
                }
              }
            }
            if (item.addTableList.sku_id) {
              for (let i = 0; i < this.SkuList.length; i++) {
                if (item.addTableList.sku_id == this.SkuList[i].key) {
                  item.addTableList.sku_name = this.SkuList[i].value1
                }
              }
            }
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER
              let arr = this.QUARTER.split('Q')
              let year = arr[0].slice(0, 4)
              item.addTableList.date_name = `${year}年第${arr[1]}季度`
            } else if (this.WEEK) {
              item.addTableList.info_date = this.WEEK
              let arr = this.WEEK.split('W')
              let year = arr[0].slice(0, 4)
              let month = arr[0].slice(4)
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

            } else {
              item.addTableList.date_name = item.addTableList.info_date
            }
            item.field_value.push(item.addTableList)
          }

          item.isAddTable = false
          item.addTableList = {
            id: '',
            dept_id: '',
            dept_name: '',
            product_id: '',
            product_name: '',
            sku_id: '',
            sku_name: '',
            info_date: '',
            date_name: '',
            field_value: ''
          }
          this.$forceUpdate()


        }
      })

    },
    addTableDataDis(item) {

      this.$refs["addTableHcp"][0].validate(valid => {
        if (!valid) {
          return false
        } else {


          if (this.QUARTER) {
            item.addTableList.info_date = this.QUARTER
            let arr = this.QUARTER.split('Q')
            let year = arr[0].slice(0, 4)
            item.addTableList.date_name = `${year}年第${arr[1]}季度`
          }
          if (this.WEEK) {
            item.addTableList.info_date = this.WEEK
            let arr = this.WEEK.split('W')
            let year = arr[0].slice(0, 4)
            let month = arr[0].slice(4)
            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

          }

          if (item.addTableList.id) {//编辑
            for (let i = 0; i < item.field_value.length; i++) {
              if (item.addTableList.id == item.field_value[i].id) {
                item.field_value[i].dept_id = item.addTableList.dept_id
                if (item.addTableList.dept_id) {
                  for (let j = 0; j < this.administrativeList.length; j++) {
                    if (item.addTableList.dept_id == this.administrativeList[j].key) {
                      item.addTableList.dept_name = this.administrativeList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].dept_name = item.addTableList.dept_name
                item.field_value[i].product_id = item.addTableList.product_id
                if (item.addTableList.product_id) {
                  for (let j = 0; j < this.productList.length; j++) {
                    if (item.addTableList.product_id == this.productList[j].key) {
                      item.addTableList.product_name = this.productList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].product_name = item.addTableList.product_name
                item.field_value[i].sku_id = item.addTableList.sku_id
                if (item.addTableList.sku_id) {
                  for (let j = 0; j < this.SkuList.length; j++) {
                    if (item.addTableList.sku_id == this.SkuList[j].key) {
                      item.addTableList.sku_name = this.SkuList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].sku_name = item.addTableList.sku_name
                item.field_value[i].info_date = item.addTableList.info_date
                item.field_value[i].date_name = item.addTableList.date_name
                item.field_value[i].field_value = item.addTableList.field_value
              }
            }
          } else {//新增
            item.addTableList.id = this.getUuid()
            if (item.addTableList.dept_id) {
              for (let i = 0; i < this.administrativeList.length; i++) {
                if (item.addTableList.dept_id == this.administrativeList[i].key) {
                  item.addTableList.dept_name = this.administrativeList[i].value1
                }
              }
            }
            if (item.addTableList.product_id) {
              for (let i = 0; i < this.productList.length; i++) {
                if (item.addTableList.product_id == this.productList[i].key) {
                  item.addTableList.product_name = this.productList[i].value1
                }
              }
            }
            if (item.addTableList.sku_id) {
              for (let i = 0; i < this.SkuList.length; i++) {
                if (item.addTableList.sku_id == this.SkuList[i].key) {
                  item.addTableList.sku_name = this.SkuList[i].value1
                }
              }
            }
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER
              let arr = this.QUARTER.split('Q')
              let year = arr[0].slice(0, 4)
              item.addTableList.date_name = `${year}年第${arr[1]}季度`
            } else if (this.WEEK) {
              item.addTableList.info_date = this.WEEK
              let arr = this.WEEK.split('W')
              let year = arr[0].slice(0, 4)
              let month = arr[0].slice(4)
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

            } else {
              item.addTableList.date_name = item.addTableList.info_date
            }
            item.field_value.push(item.addTableList)
          }


          item.isAddTable = false
          item.addTableList = {
            id: '',
            dept_id: '',
            dept_name: '',
            product_id: '',
            product_name: '',
            sku_id: '',
            sku_name: '',
            info_date: '',
            date_name: '',
            field_value: ''
          }
          this.$forceUpdate()


        }
      })

    },

    cancelTableData(item) {
      item.isAddTable = false
      item.addTableList = {
        id: '',
        dept_id: '',
        dept_name: '',
        product_id: '',
        product_name: '',
        sku_id: '',
        sku_name: '',
        info_date: '',
        date_name: '',
        field_value: ''
      }
      this.$forceUpdate()

    },
    parentEvent(data) {
      this.addTableList.info_date = data
    },
    getQuarterValue(a, b) {
      this.QUARTER = a + 'Q' + b
    },
    getWeekValue(a, b, c) {
      let month = b.toString()
      this.WEEK = a + month + 'W' + c
      console.log(this.WEEK)
    },
    parentWeekEvent(data) {
      this.addTableList.info_date = data
    },
    handleTableClick(index, row, item) {
      this.delateFalse = true
      item.isAddTable = true
      this.getSkuList(row.product_id)
      item.addTableList = {
        id: row.id,
        dept_id: row.dept_id,
        dept_name: row.dept_name,
        product_id: row.product_id,
        product_name: row.product_name,
        sku_id: row.sku_id,
        sku_name: row.sku_name,
        info_date: row.info_date,
        date_name: row.date_name,
        field_value: row.field_value,
      }
      this.$forceUpdate()

    },
    onSearchResult1(pois) {

      this.locationForm.address = pois[0].address;    //获取到位置
      this.locationForm.location_name = pois[0].name;    //获取到位置
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        this.centers1_1 = []
        this.edit_markers1.position = []
//                    pois.forEach(poi => {
        let {lng, lat} = pois[0];
        lngSum += lng;
        latSum += lat;
        this.centers1_1.push([pois[0].lng, pois[0].lat]);
        this.edit_markers1.position = [pois[0].lng, pois[0].lat];

//                    });
        let center = {
          lng: lngSum,/// pois.length,
          lat: latSum /// pois.length
        };
        this.center1_1 = [center.lng, center.lat];
        Message({
          type: 'success',
          message: '坐标已选取'
        })
      }
    },
    onSearchResult2(pois) {

      this.locationForm.address = pois[0].address;    //获取到位置
      this.locationForm.location_name = pois[0].name;    //获取到位置
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        this.centers2_1 = []
        this.edit_markers1.position = []
//                    pois.forEach(poi => {
        let {lng, lat} = pois[0];
        lngSum += lng;
        latSum += lat;
        this.centers2_1.push([pois[0].lng, pois[0].lat]);
        this.edit_markers1.position = [pois[0].lng, pois[0].lat];

//                    });
        let center = {
          lng: lngSum,/// pois.length,
          lat: latSum /// pois.length
        };
        this.center2_1 = [center.lng, center.lat];
        Message({
          type: 'success',
          message: '坐标已选取'
        })
      }
    },

    onSearchResult3(pois) {

      this.locationForm.address = pois[0].address;    //获取到位置
      this.locationForm.location_name = pois[0].name;    //获取到位置
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        this.centers3_1 = []
        this.edit_markers1.position = []
//                    pois.forEach(poi => {
        let {lng, lat} = pois[0];
        lngSum += lng;
        latSum += lat;
        this.centers3_1.push([pois[0].lng, pois[0].lat]);
        this.edit_markers1.position = [pois[0].lng, pois[0].lat];

//                    });
        let center = {
          lng: lngSum,/// pois.length,
          lat: latSum /// pois.length
        };
        this.center3_1 = [center.lng, center.lat];
        Message({
          type: 'success',
          message: '坐标已选取'
        })
      }
    },
    onSearchResult4(pois) {
      this.locationForm.address = pois[0].address;    //获取到位置
      this.locationForm.location_name = pois[0].name;
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        this.center4_1 = []
        let {lng, lat} = pois[0];
        lngSum += lng;
        latSum += lat;
        this.center4_1 = [pois[0].lng, pois[0].lat];
        this.locationInfo[this.mydiv].lng = pois[0].lng
        this.locationInfo[this.mydiv].lat = pois[0].lat
        this.locationInfo[this.mydiv].address = pois[0].address
        this.locationInfo[this.mydiv].location_name = pois[0].name
        this.markers.splice(0, 1, [this.locationInfo[this.mydiv].lng, this.locationInfo[this.mydiv].lat])
        // let center = {
        //     lng: lngSum,/// pois.length,
        //     lat: latSum /// pois.length
        // };
        // this.center2_1 = [center.lng, center.lat];
        Message({
          type: 'success',
          message: '坐标已选取'
        })
      }
    },
    getUuid1() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      this.uuid = uuid

    },
    step1Click() {
      if (this.activeStyle == 1) {
        this.getInstitutionsFrom()
        this.getStoreFrom()
        this.getDistributorFrom()
      } else if (this.activeStyle == 2) {
        this.getUuid1()
      }
      this.steps = 2
      this.stepsName = 1
      this.changeIns = false
      this.markers = []
      // this.center4_1=[]
      this.activeName1 = 'first'
      this.locationForm = {
        location_name: '',
        address: ''
      }
      this.locationInfo = []
      this.institution_id = ''
      this.store_id = ''
      this.distributor_id = ''
      this.basicInfoForm = {}
      this.centers = []
      this.centers2 = []
      this.centers3 = []
      this.centers1_1 = []
      this.centers2_1 = []
      this.centers3_1 = []
    },
    steps2Click() {
      this.steps = 1
      this.stepsName = 0
    },
    steps3Click() {
      if ((this.activeStyle == 3 || this.activeStyle == 4) && this.tableInstutionsList.length > 0) {
        for (var i = 0; i < this.tableInstutionsList.length; i++) {
          if (this.institution_id == this.tableInstutionsList[i].institution_id) {
            if (this.tableInstutionsList[i].productArray.length > 0) {
              this.jurisdictionForm.productArray = []
              for (var j = 0; j < this.tableInstutionsList[i].productArray.length; j++) {
                this.jurisdictionForm.productArray.push(this.tableInstutionsList[i].productArray[j].product_id)
              }
            } else {
              this.jurisdictionForm.productArray = []
            }
          }

        }
      }
      if ((this.activeStyle == 3 || this.activeStyle == 4) && this.tableRetailstoreList.length > 0) {
        for (var i = 0; i < this.tableRetailstoreList.length; i++) {
          if (this.store_id == this.tableRetailstoreList[i].store_id) {
            if (this.tableRetailstoreList[i].productArray.length > 0) {
              this.jurisdictionForm.productArray = []
              for (var j = 0; j < this.tableRetailstoreList[i].productArray.length; j++) {
                this.jurisdictionForm.productArray.push(this.tableRetailstoreList[i].productArray[j].product_id)
              }
            } else {
              this.jurisdictionForm.productArray = []
            }

          }

        }
      }
      if ((this.activeStyle == 3 || this.activeStyle == 4) && this.tableDistributorList.length > 0) {
        for (var i = 0; i < this.tableDistributorList.length; i++) {
          if (this.distributor_id == this.tableDistributorList[i].distributor_id) {
            if (this.tableDistributorList[i].productArray.length > 0) {
              this.jurisdictionForm.productArray = []
              for (var j = 0; j < this.tableDistributorList[i].productArray.length; j++) {
                this.jurisdictionForm.productArray.push(this.tableDistributorList[i].productArray[j].product_id)
              }
            } else {
              this.jurisdictionForm.productArray = []
            }

          }

        }
      }
      if (this.activeStyle == 1 || this.activeStyle == 3 || this.activeStyle == 4) {
        if (this.activeName == 'first' && this.institution_id == '') {
          this.activeName1 = 'first'
          Message({
            type: 'error',
            message: '请先选择机构'
          })

        } else if (this.activeName == 'second' && this.store_id == '') {
          this.activeName1 = 'first'
          Message({
            type: 'error',
            message: '请先选择门店'
          })
        } else if (this.activeName == 'third' && this.distributor_id == '') {
          this.activeName1 = 'first'
          Message({
            type: 'error',
            message: '请先选择经销商'
          })
        } else {
          for (let i = 0; i < this.locationInfo.length; i++) {
            let obj = this.locationInfo[i]
            if (obj.lng == undefined || obj.lat == undefined) {
              Message({
                type: 'error',
                message: '坐标未选取'
              })
              return false
            } else if (obj.location_name == '') {
              Message({
                type: 'error',
                message: '名称未填写'
              })
              return false
            } else if (obj.address == '') {
              Message({
                type: 'error',
                message: '地址未填写'
              })
              return false
            }
          }
          this.steps = 3
          this.stepsName = 2
        }

      } else if (this.activeStyle == 2) {
        if (this.activeName == 'first') { //机构的字段判断
          this.$refs["addBasicInfoForm"].validate(valid => {
            if (!valid) {
              this.activeName1 = 'first'
              return false
            } else {
              let off = true


              for (var i = 0; i < this.extendedInfo1_2.length; i++) {
                for (var j = 0; j < this.extendedInfo1_2[i].fieldArray.length; j++) {
                  if (this.extendedInfo1_2[i].fieldArray[j].mandatory == 'T') {

                    this.$refs['extendedInfo1_2' + i + j][0].validate(valid => {
                      if (!valid) {

                        console.log(this.extendedInfo1_2[i].name)
                        this.activeName1 = this.extendedInfo1_2[i].name
                        off = false

                      }
                    })

                  }
                }

              }
              if (off) {
                this.steps = 3
                this.stepsName = 2
              }

            }
          })


        } else if (this.activeName == 'second') { //门店字段判断
          this.$refs["pushStoreList"].validate(valid => {
            if (!valid) {
              this.activeName1 = 'first'
              return false
            } else {
              let off = true
              for (var i = 0; i < this.extendedInfo2_2.length; i++) {
                for (var j = 0; j < this.extendedInfo2_2[i].fieldArray.length; j++) {
                  if (this.extendedInfo2_2[i].fieldArray[j].mandatory == 'T') {

                    this.$refs['extendedInfo2_2' + i + j][0].validate(valid => {
                      if (!valid) {

                        console.log(this.extendedInfo2_2[i].name)
                        this.activeName1 = this.extendedInfo2_2[i].name
                        off = false

                      }
                    })

                  }
                }

              }
              if (off) {
                this.steps = 3
                this.stepsName = 2
              }


            }
          })
        } else { //经销商字段判断
          this.$refs["pushDistributorList"].validate(valid => {
            if (!valid) {
              this.activeName1 = 'first'
              return false
            } else {
              let off = true
              for (var i = 0; i < this.extendedInfo3_2.length; i++) {
                for (var j = 0; j < this.extendedInfo3_2[i].fieldArray.length; j++) {
                  if (this.extendedInfo3_2[i].fieldArray[j].mandatory == 'T') {

                    this.$refs['extendedInfo3_2' + i + j][0].validate(valid => {
                      if (!valid) {

                        console.log(this.extendedInfo3_2[i].name)
                        this.activeName1 = this.extendedInfo3_2[i].name
                        off = false

                      }
                    })

                  }
                }

              }
              if (off) {
                this.steps = 3
                this.stepsName = 2
              }

            }
          })
        }
      }
    },
    steps4Click() {
      this.steps = 2
      this.stepsName = 1

    },
    steps5Click() {

      if (this.activeName == 'first') {
        if (this.activeStyle == 1) {
          this.$refs["institutionForm"].validate(valid => {
            if (!valid) {
              return false
            } else {
              this.getUuid1()
              this.setProductArray()
            }
          })
        } else if (this.activeStyle == 2) {
          this.$refs["institutionForm"].validate(valid => {
            if (!valid) {
              return false
            } else {
              this.getUuid1()
              this.institution_id = this.uuid
              this.getUuid1()
              this.addInstitution1()
              if (this.locationForm.location_name) {
                this.baocunLocation1()
              }
              this.updateExtendedInfo1()
              this.setProductArray1_2()
            }
          })
        } else if (this.activeStyle == 4) {
          let type = 'INSTITUTION'
          this.submitLocation(type)

        } else {
          this.getUuid1()
          this.setProductArray1_3()
        }


      }
      else if (this.activeName == 'second') {
        if (this.activeStyle == 1) {
          this.$refs["storeForm"].validate(valid => {
            if (!valid) {
              return false
            } else {
              this.getUuid1()
              this.setProductArray2()
            }
          })
        } else if (this.activeStyle == 2) {
          this.$refs["storeForm"].validate(valid => {
            if (!valid) {
              return false
            } else {
              this.getUuid1()
              this.store_id = this.uuid
              this.getUuid1()
              this.addRetailstore1()
              if (this.locationForm.location_name) {
                this.setRetailstoreLocation()
              }
              this.updateStoreExtendedInfo()
              this.setProductArray2_2()
            }
          })

        } else if (this.activeStyle == 4) {
          let type = 'RETAILSTORE'
          this.submitLocation(type)

        } else {
          this.getUuid1()
          this.setProductArray2_3()
        }

      }
      else {

        if (this.activeStyle == 1) {
          this.$refs["distributorForm"].validate(valid => {
            if (!valid) {
              return false
            } else {
              this.getUuid1()
              this.setProductArray3()
            }
          })
        } else if (this.activeStyle == 2) {
          this.$refs["distributorForm"].validate(valid => {
            if (!valid) {
              return false
            } else {
              this.getUuid1()
              this.distributor_id = this.uuid
              this.getUuid1()
              this.addDistributor1()
              if (this.locationForm.location_name) {
                this.setDistributorLocation()
              }
              this.updateDistributorExtendedInfo()
              this.setProductArray3_2()
            }
          })
        } else if (this.activeStyle == 4) {
          let type = 'DISTRIBUTOR'
          this.submitLocation(type)

        } else {
          this.getUuid1()
          this.setProductArray3_3()
        }
      }


    },
    steps6Click() {
      this.stepsName = 4
    },
    clickActiveStyle(index) {
      this.jurisdictionForm.productArray = []
      this.activeStyle = index
      if (this.activeStyle == 1) {
        this.getInstitutionsFrom()
        this.getStoreFrom()
        this.getDistributorFrom()
      } else if (this.activeStyle == 3 || this.activeStyle == 4) {
        if (this.tableInstutionsList.length > 0) {
          this.institutionsForm = this.tableInstutionsList
        } else {
          this.institutionsForm = []
        }
        if (this.tableRetailstoreList.length > 0) {
          this.storeForm = this.tableRetailstoreList
        } else {
          this.storeForm = []
        }
        if (this.tableDistributorList.length > 0) {
          this.distributorForm = this.tableDistributorList
        } else {
          this.distributorForm = []
        }


      }
    },

    // 新增机构
    async addInstitution1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_name: this.addBasicInfoForm.institution_name,
        institution_type: this.addBasicInfoForm.institution_type,
        institution_grade: this.addBasicInfoForm.institution_grade,
        institution_id: this.institution_id,
        enrollment_id: this.uuid,
        institution_code: this.addBasicInfoForm.institution_code,
        province_id: this.addBasicInfoForm.province_id,
        city_id: this.addBasicInfoForm.city_id,
        address: this.addBasicInfoForm.address,
        telephone: this.addBasicInfoForm.telephone,
        postcode: this.addBasicInfoForm.postcode,
        website: this.addBasicInfoForm.website,
        distributor_id: this.addBasicInfoForm.distributor_id,
        user_id: this.$store.getters.getUser.user_id,
        agreement_signed: this.addBasicInfoForm.agreement_signed,
        agreement_stage: this.addBasicInfoForm.agreement_stage
      }
//                let self = this
      await http.post('/wapi/Institution/addInstitution1', data).then(res => {

        if (res.success) {
        } else {
          Message.error(res.message);
        }
      })
    },
    async updateExtendedInfo1() {


      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        institution_id: this.institution_id,
        enrollment_id: this.uuid,
        ExtensionArray: this.extendedInfo1_2
      }
      await http.post('/wapi/Institution/setExtendedList1_2', data).then(res => {

        if (res.success) {
        } else {
          Message.error(res.message);

        }
      })
    },
    async baocunLocation1() {

      let data = {
        user_id: this.$store.getters.getUser.user_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
        location_name: this.locationForm.location_name,
        address: this.locationForm.address,
        reference_obj: 'INSTITUTION',
        reference_id: this.institution_id,
        enrollment_id: this.uuid,
        lng: this.edit_markers1.position[0],
        lat: this.edit_markers1.position[1],
      }

      await http.post('/wapi/Institution/setLocation1', data).then(res => {
        if (res.success = true) {
        }

      })
    },

    // 机构提交产品
    setProductArray() {
      // console.log(this.jurisdictionForm.productArray)
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        enrollment_id: this.uuid,
        institution_id: this.institution_id,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment()
        } else {
          Message.error(res.message);
        }
      })

    },
    setProductArray1_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        institution_id: this.institution_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment1_2()
        } else {
          Message.error(res.message);
        }
      })

    },
    setProductArray1_3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        institution_id: this.institution_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment1_3()
        } else {
          Message.error(res.message);
        }
      })

    },

    //机构提交申请理由
    setTerritoryEnrollment() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.institution_id,
        enrollment_id: this.uuid,
        enrollment_type: 'ADD',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },
    setTerritoryEnrollment1_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.institution_id,
        enrollment_id: this.uuid,
        enrollment_type: 'NEW',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },
    setTerritoryEnrollment1_3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.institution_id,
        enrollment_id: this.uuid,
        enrollment_type: 'REMOVE',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },
    // 新增门店
    async addRetailstore1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_name: this.pushStoreList.store_name,
        store_type: this.pushStoreList.store_type,
        store_id: this.store_id,
        enrollment_id: this.uuid,
        retailstore_grade: this.pushStoreList.retailstore_grade,
        province_id: this.pushStoreList.province_id,
        city_id: this.pushStoreList.city_id,
        institution_id: this.pushStoreList.institution_id,
        address: this.pushStoreList.address,
        telephone: this.pushStoreList.telephone,
        postcode: this.pushStoreList.postcode,
        website: this.pushStoreList.website,
        distributor_id: this.pushStoreList.distributor_id,
        user_id: this.$store.getters.getUser.user_id,
        store_code: this.pushStoreList.store_code,
        agreement_signed: this.pushStoreList.agreement_signed,
        agreement_stage: this.pushStoreList.agreement_stage
      }
//                let self = this
      await http.post('/wapi/Retailstore/addRetailstore1', data).then(res => {

        if (res.success) {

        } else {
          Message.error(res.message);
        }
      })
    },
    async setRetailstoreLocation() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_id: this.store_id,
        enrollment_id: this.uuid,
        location_name: this.locationForm.location_name,
        address: this.locationForm.address,
        lat: this.edit_markers1.position[1],
        lng: this.edit_markers1.position[0],
        user_id: this.$store.getters.getUser.user_id,
      }

      await http.post('/wapi/Retailstore/setRetailstoreLocation1', data).then(res => {

        if (res.success) {
          this.getRetailstoreInfo()
        } else {
          Message.error(res.message);
        }
      })
    },
    async updateStoreExtendedInfo() {

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.store_id,
        enrollment_id: this.uuid,
        ExtensionArray: this.extendedInfo2_2
      }
      await http.post('/wapi/Retailstore/setExtendedList1', data).then(res => {

        if (res.success) {
        } else {
          Message.error(res.message);

        }
      })
    },

    // 门店提交产品
    setProductArray2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        store_id: this.store_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray2', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment2()
        } else {
          Message.error(res.message);
        }
      })

    },
    setProductArray2_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        store_id: this.store_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray2', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment2_2()
        } else {
          Message.error(res.message);
        }
      })

    },
    setProductArray2_3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        store_id: this.store_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray2', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment2_3()
        } else {
          Message.error(res.message);
        }
      })

    },

    //门店提交申请理由
    setTerritoryEnrollment2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.store_id,
        enrollment_id: this.uuid,
        enrollment_type: 'ADD',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment2', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },
    setTerritoryEnrollment2_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.store_id,
        enrollment_id: this.uuid,
        enrollment_type: 'NEW',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment2', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },
    setTerritoryEnrollment2_3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.store_id,
        enrollment_id: this.uuid,
        enrollment_type: 'REMOVE',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment2', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },

    // 新增经销商
    async addDistributor1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_name: this.pushDistributorList.distributor_name,
        distributor_code: this.pushDistributorList.distributor_code,
        distributor_id: this.distributor_id,
        enrollment_id: this.uuid,
        distributor_type: this.pushDistributorList.distributor_type,
        distributor_grade: this.pushDistributorList.distributor_grade,
        province_id: this.pushDistributorList.province_id,
        city_id: this.pushDistributorList.city_id,
        address: this.pushDistributorList.address,
        telephone: this.pushDistributorList.telephone,
        postcode: this.pushDistributorList.postcode,
        website: this.pushDistributorList.website,
        user_id: this.$store.getters.getUser.user_id,
        agreement_signed: this.pushDistributorList.agreement_signed,
        agreement_stage: this.pushDistributorList.agreement_stage
      }

      await http.post('/wapi/Distributor/addDistributor1', data).then(res => {

        if (res.success) {

        } else {
          Message.error(res.message);
        }
      })
    },
    async setDistributorLocation() {

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: this.distributor_id,
        enrollment_id: this.uuid,
        location_name: this.locationForm.location_name,
        address: this.locationForm.address,
        lat: this.edit_markers1.position[1],
        lng: this.edit_markers1.position[0],
        user_id: this.$store.getters.getUser.user_id
      }

      await http.post('/wapi/Distributor/setDistributorLocation1', data).then(res => {

        if (res.success) {
        } else {
          Message.error(res.message);
        }
      })
    },
    async updateDistributorExtendedInfo() {


      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        distributor_id: this.distributor_id,
        enrollment_id: this.uuid,
        ExtensionArray: this.extendedInfo3_2
      }
      await http.post('/wapi/Distributor/setExtendedList1', data).then(res => {

        if (res.success) {
        } else {
          Message.error(res.message);

        }
      })
    },

    // 经销商提交产品
    setProductArray3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        distributor_id: this.distributor_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }

      http.post('/wapi/JurActive/setProductArray3', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment3()
        } else {
          Message.error(res.message);
        }
      })

    },
    setProductArray3_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        distributor_id: this.distributor_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray3', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment3_2()
        } else {
          Message.error(res.message);
        }
      })
    },
    setProductArray3_3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        distributor_id: this.distributor_id,
        enrollment_id: this.uuid,
        productArray: this.jurisdictionForm.productArray,
        user_id: this.$store.getters.getUser.user_id,
      }
      http.post('/wapi/JurActive/setProductArray3', data).then(res => {
        if (res.success) {
          this.setTerritoryEnrollment3_3()
        } else {
          Message.error(res.message);
        }
      })

    },
    //经销商提交申请理由
    setTerritoryEnrollment3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.distributor_id,
        enrollment_id: this.uuid,
        enrollment_type: 'ADD',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment3', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },
    setTerritoryEnrollment3_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.distributor_id,
        enrollment_id: this.uuid,
        enrollment_type: 'NEW',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment3', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },
    setTerritoryEnrollment3_3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_id: this.distributor_id,
        enrollment_id: this.uuid,
        enrollment_type: 'REMOVE',
        // effective_date:this.jurisdictionForm.effective_date,
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id
      }
      http.post('/wapi/JurActive/setTerritoryEnrollment3', data).then(res => {
        if (res.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message.error(res.message);
        }
      })
    },

    systemConfiguration() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
        }
        http.post('/wapi/JurActive/systemConfiguration', data).then(res => {
          if (res.success === true) {
            this.systemConfig = res.data
          }

        })
      } catch (e) {

      }
    },
    getCity() {
      try {
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        http.post('/wapi/JurActive/getCityList', data).then(res => {
          if (res.success === true) {
            this.cityList = res.data
          }

        })
      } catch (e) {

      }
    },
    async getinstitution_list() {
      try {
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        await http.post('/wapi/JurActive/getInstitutions', data).then(res => {
          if (res.success === true) {
            this.institution_list = res.data
          }
        })
      } catch (e) {

      }
    },
    async getstore_list() {
      try {
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        await http.post('/wapi/JurActive/getStore', data).then(res => {
          if (res.success === true) {
            this.store_list = res.data

          }
        })
      } catch (e) {

      }
    },
    async getdistributor_list() {
      try {
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        await http.post('/wapi/JurActive/getDistributor', data).then(res => {
          if (res.success === true) {
            this.distributor_list = res.data

          }
        })
      } catch (e) {

      }
    },
    querySearchAsync(queryString, cb) {
      if (this.medicalName == true) {
        var sr = [];
        if (queryString != undefined && queryString.length > 0) {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.queryString = queryString.trim()
          http.post('/wapi/JurActive/getInstitutions', data).then(res => {
            if (res.success === true) {
              // let data = res.data
              // for (let i of data){
              //     i.value = i.institution_name
              // }
              // cb(data)
              cb(res.data)
            }

          })

        } else {
          cb(sr);
        }
      } else if (this.retailName === true) {
        var sr = [];
        if (queryString != undefined && queryString.length > 0) {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.queryString = queryString.trim()
          http.post('/wapi/JurActive/getStore', data).then(res => {
            if (res.success === true) {
              //
              // let data = res.data
              // for (let i of data){
              //     i.value = i.store_name
              // }
              // cb(data)
              cb(res.data)
            }

          })

        } else {
          cb(sr);
        }
      } else if (this.distributionName == true) {
        var sr = [];
        if (queryString != undefined && queryString.length > 0) {
          let data = {}
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.queryString = queryString.trim()
          http.post('/wapi/JurActive/getDistributor', data).then(res => {
            if (res.success === true) {
              //
              // let data = res.data
              // for (let i of data){
              //     i.value = i.store_name
              // }
              // cb(data)
              cb(res.data)
            }

          })

        } else {
          cb(sr);
        }
      }

    },
    handleSelect(item) {
      this.addFormInstiturions.institution_id = item
      // this.addFormInstiturions.institution_name = item.institution_name
    },
    handleSelectStore(item) {
      this.addFormStore.store_id = item
      // this.addFormStore.store_name = item.store_name
    },
    handleSelectDistributorList(item) {
      this.addFormDistributorList.distributor_id = item
      // this.addFormDistributorList.distributor_name = item.distributor_name
    },
    async getInstutionsList() {
      try {
        this.loading = true
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        //this.loading = false
        await http.post('/wapi/JurActive/getInstutionsList', data).then(res => {
          //console.log(res)

          if (res.success) {
            // this.loading = false
          }

          this.tableInstutionsList = res.data.array
          if (this.tableInstutionsList.length > 0) {
            this.tableInstutionsListLength = this.tableInstutionsList.length
          } else {
            this.tableInstutionsListLength = 0
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      } catch (e) {
        this.loading = false
      }
    },
    async getRetailstoreList() {

      try {
        this.loading = true
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        //this.loading = false
        await http.post('/wapi/JurActive/getRetailstoreList', data).then(res => {
          if (res.success) {
            //this.loading = false
          }
          this.tableRetailstoreList = res.data.array
          if (this.tableRetailstoreList.length > 0) {
            this.tableRetailstoreListLength = this.tableRetailstoreList.length
          } else {
            this.tableRetailstoreListLength = 0
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })

      } catch (e) {
        this.loading = false
      }

    },
    async getDistributorList() {

      try {
        this.loading = true
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        //this.loading = false
        await http.post('/wapi/JurActive/getDistributorList', data).then(res => {
          // console.log(res,222)
          if (res.success) {
            //this.loading = false
          }
          this.tableDistributorList = res.data.array
          if (this.tableDistributorList.length > 0) {
            this.tableDistributorListLength = this.tableDistributorList.length
          } else {
            this.tableDistributorListLength = 0
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })

      } catch (e) {
        this.loading = false
      }

    },
    async getProductList() {
      try {
        this.loading = true
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        //this.loading = false
        await http.post('/wapi/JurActive/getProductList', data).then(res => {
          this.product_num = res.data.product_num
        })

      } catch (e) {
        this.loading = false
      }
    },
    async addProductArray_fn(id, type) {
      try {
        // this.loading = true
        let data = this.$store.getters.getDataInfo
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.id = id
        data.type = type
        //this.loading = false
        await http.post('/wapi/JurActive/addProductArray', data).then(res => {
          console.log(res.data, 5424)
          this.addProductArray = res.data
        })

      } catch (e) {
        // this.loading = false
      }
    },
    info(a, b) {

    },
    clickModelInstutionsList(index, row) {
      this.modelInstitutions = true
      this.formInstiturions.territory_name = this.data.territory_name
      this.formInstiturions.territory_code = this.data.territory_code
      this.formInstiturions.territory_id = this.data.territory_id
      this.formInstiturions.institution_name = row.institution_name
      this.formInstiturions.institution_name = row.institution_name
      this.formInstiturions.institution_id = row.institution_id
      this.addProductArray_fn(row.institution_id, 'INSTITUTION')
      this.formInstiturions.productArray = []
      this.formInstiturions.productArraySelect = []
      for (let i = 0; i < row.productArray.length; i++) {
        this.formInstiturions.productArray.push(row.productArray[i].product_id)
        this.formInstiturions.productArraySelect.push(row.productArray[i].product_id)
      }
    },
    clickModelRetailstoreList(index, row) {
      this.modelRetailstoreList = true
      this.formRetailstoreList.territory_name = this.data.territory_name
      this.formRetailstoreList.territory_code = this.data.territory_code
      this.formRetailstoreList.territory_id = this.data.territory_id
      this.formRetailstoreList.store_name = row.store_name
      this.formRetailstoreList.store_id = row.store_id
      this.addProductArray_fn(row.store_id, 'RETAILSTORE')
      this.formRetailstoreList.productArray = []
      this.formRetailstoreList.productArraySelect = []
      for (let i = 0; i < row.productArray.length; i++) {
        this.formRetailstoreList.productArray.push(row.productArray[i].product_id)
        this.formRetailstoreList.productArraySelect.push(row.productArray[i].product_id)
      }
    },
    clickModelDistributorList(index, row) {
      // console.log(row)
      this.modelDistributorList = true
      this.formDistributorList.territory_name = this.data.territory_name
      this.formDistributorList.territory_code = this.data.territory_code
      this.formDistributorList.territory_id = this.data.territory_id
      this.formDistributorList.distributor_name = row.distributor_name
      this.formDistributorList.distributor_id = row.distributor_id
      this.addProductArray_fn(row.distributor_id, 'DISTRIBUTOR')
      this.formDistributorList.productArray = []
      this.formDistributorList.productArraySelect = []
      for (let i = 0; i < row.productArray.length; i++) {
        this.formDistributorList.productArray.push(row.productArray[i].product_id)
        this.formDistributorList.productArraySelect.push(row.productArray[i].product_id)
      }
    },
    emoveTag(tag) {
      //console.log(tag)
    },
    addJurisdiction() {
      if (this.activeName == 'first') { //医疗机构
        this.getExtendedInfo1_2()
        this.institution_id = ''
        this.activeStyle = 1
        this.activeName1 = 'first'
        this.basicInfoForm = {}
        this.locationForm = {
          location_name: '',
          address: ''
        },
            this.jurisdictionForm = {
              effective_date: 'D',
              productArray: [],
              textarea: ''
            }
        this.addModelJurisdiction = true
        this.steps = 1
        this.stepsName = 0
      } else if (this.activeName == 'second') { //零售终端
        this.getRetailstoreGardeList1()
        this.getStoreTypeList()
        this.getExtendedInfo2_2()
        this.store_id = ''
        this.activeStyle = 1
        this.activeName1 = 'first'
        this.basicInfoForm = {}
        this.locationForm = {
          location_name: '',
          address: ''
        },
            this.jurisdictionForm = {
              effective_date: 'D',
              productArray: [],
              textarea: ''
            }
        this.addModelJurisdiction2 = true
        this.steps = 1
        this.stepsName = 0

      } else { //分销客户
        setTimeout(() => {
          this.onoffmap = true
        }, 1000)
        this.getDistributorGardeList1()
        this.getDistributorExtendedInfo()
        this.distributor_id = ''
        this.activeStyle = 1
        this.activeName1 = 'first'
        this.basicInfoForm = {}
        this.locationForm = {
          location_name: '',
          address: ''
        },
            this.jurisdictionForm = {
              effective_date: 'D',
              productArray: [],
              textarea: ''
            }
        this.addModelJurisdiction3 = true
        this.steps = 1
        this.stepsName = 0
      }
    },
    addInstitutions() {
      // console.log(this.addFormInstiturions)
      this.addModelInstitutions = true
      this.addFormInstiturions.territory_name = this.data.territory_name
      this.addFormInstiturions.territory_code = this.data.territory_code
      this.addFormInstiturions.territory_id = this.data.territory_id
    },
    addStore() {
      this.addModelStore = true
      this.addFormStore.territory_name = this.data.territory_name
      this.addFormStore.territory_code = this.data.territory_code
      this.addFormStore.territory_id = this.data.territory_id
    },
    addDistributor() {
      this.addModelDistributorList = true
      this.addFormDistributorList.territory_name = this.data.territory_name
      this.addFormDistributorList.territory_code = this.data.territory_code
      this.addFormDistributorList.territory_id = this.data.territory_id
    },
    async saveAddInstitutions() {
      try {
        let data = this.addFormInstiturions
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.month = new Date().Format('yyyyMM')
        if (!data.institution_id) {
          this.$message({
            type: 'error',
            message: '请选择机构'
          })
          return false
        }
        if (data.productArray.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择推广产品'
          })
        } else {
          await http.post('/wapi/JurActive/addInstitutions', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getInstutionsList()
              this.getProductList()

              let obj = {
                productArray: [],
                territory_name: '',
                territory_code: '',
                institution_name: '',
                territory_id: '',
                institution_id: ''
              }
              this.sname = ''
              this.addFormInstiturions = obj
              // console.log(this.addFormInstiturions)
            }
          })
          this.addModelInstitutions = false
        }

      } catch (e) {

      }
    },
    async saveAddStore() {
      try {
        let data = this.addFormStore
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.month = new Date().Format('yyyyMM')
        // console.log(data)
        if (!data.store_id) {
          this.$message({
            type: 'error',
            message: '请选择门店'
          })
          return false
        }
        if (data.productArray.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择推广产品'
          })
        } else {
          await http.post('/wapi/JurActive/addStore', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getRetailstoreList()
              this.getProductList()

              let obj = {
                productArray: [],
                territory_name: '',
                territory_code: '',
                store_name: '',
                territory_id: '',
                store_id: ''
              }
              this.snamestore = ''
              this.addFormStore = obj
            }
          })
          this.addModelStore = false
        }
      } catch (e) {

      }
    },
    async saveAddDistributorList() {
      try {
        let data = this.addFormDistributorList
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.month = new Date().Format('yyyyMM')

        if (!data.distributor_id) {
          this.$message({
            type: 'error',
            message: '请选择经销商'
          })
          return false
        }
        if (data.productArray.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择推广产品'
          })
        } else {
          await http.post('/wapi/JurActive/addDistributorList', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getDistributorList()
              this.getProductList()

              let obj = {
                productArray: [],
                territory_name: '',
                territory_code: '',
                distributor_name: '',
                territory_id: '',
                distributor_id: ''
              }
              this.addFormDistributorList = obj
              this.snameDistributorList = ''
            }
          })

          this.addModelDistributorList = false
        }
      } catch (e) {

      }
    },
    async updateInstitutions() {

      try {
        let data = this.formInstiturions
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.month = new Date().Format('yyyyMM')
        if (data.productArray.length > 0) {
          await http.post('/wapi/JurActive/upDateInstitutions', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getInstutionsList()
              this.getProductList()
            }
          })
          this.modelInstitutions = false
        } else {
          this.$message({
            type: 'error',
            message: '产品不能为空'
          })
        }

      } catch (e) {

      }
    },
    async updateRetailstoreList() {

      try {
        let data = this.formRetailstoreList
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.month = new Date().Format('yyyyMM')
        if (data.productArray.length > 0) {
          await http.post('/wapi/JurActive/upDateRetailstoreList', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getRetailstoreList()

            }
          })
          this.modelRetailstoreList = false
        } else {
          this.$message({
            type: 'error',
            message: '产品不能为空'
          })
        }

      } catch (e) {

      }
    },
    async updateDistributorList() {

      try {
        let data = this.formDistributorList
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.month = new Date().Format('yyyyMM')
        if (data.productArray.length > 0) {
          await http.post('/wapi/JurActive/updateDistributorList', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDistributorList()

            }
          })
          this.modelDistributorList = false
        } else {
          this.$message({
            type: 'error',
            message: '产品不能为空'
          })
        }

      } catch (e) {

      }
    },
    async clickRemove(index, row) {
      try {
        this.$confirm('此操作将移除机构, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = row
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.territory_id = this.data.territory_id
          http.post('/wapi/JurActive/clickRemove', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '移除成功'
              })
              this.getInstutionsList()
              this.getProductList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      } catch (e) {

      }
    },
    async clickRemoveRetailstoreList(index, row) {
      try {
        // console.log(row,22)
        this.$confirm('此操作将移除门店, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = row
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.territory_id = this.data.territory_id
          http.post('/wapi/JurActive/clickRemoveRetailstoreList', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '移除成功'
              })
              this.getRetailstoreList()

            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      } catch (e) {

      }
    },
    async clickRemoveDistributorList(index, row) {
      try {
        this.$confirm('此操作将移除经销商, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = row
          data.tenant_id = this.$store.getters.getUser.tenant_id
          data.territory_id = this.data.territory_id
          http.post('/wapi/JurActive/clickRemoveDistributorList', data).then(res => {
            if (res.success === true) {
              this.$message({
                type: 'success',
                message: '移除成功'
              })
              this.getDistributorList()

            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      } catch (e) {

      }
    },
    tabHandleClick(item) {
      if (item.label === '医疗机构') {
        this.medicalName = true
        this.retailName = false
        this.distributionName = false
      } else if (item.label === '零售终端') {
        this.medicalName = false
        this.distributionName = false
        this.retailName = true
      } else if (item.label === '分销客户') {
        this.medicalName = false
        this.retailName = false
        this.distributionName = true
      }
    },
    isShowButton() {
      if (this.whether_text === 'mymanagement') {
        return false
      } else if (this.whether_text === 'myresponsible') {
        return false
      }
      // console.log(this.whether_text)
    },
    isShowButton_D() {
      if (this.whether_text === 'mymanagement') {
        return false
      } else if (this.whether_text === 'myresponsible') {
        if (this.distributionName) {
          return true
        } else {
          return false
        }

      }
    },
    // 获取机构列表
    async getInstitutionsFrom() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        cityArray: this.cityList,
        tableInstutionsList: this.tableInstutionsList,
        territory_id: this.data.territory_id
      }
      await http.post('/wapi/JurActive/getInstitutionsFrom', data).then(res => {
        if (res.success) {
          this.institutionsForm = res.data
          // console.log(this.institutionsForm)
        }

      })
    },

    // 获取门店列表
    async getStoreFrom() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        cityArray: this.cityList,
        tableRetailstoreList: this.tableRetailstoreList,
        territory_id: this.data.territory_id
      }
      await http.post('/wapi/JurActive/getStoreFrom', data).then(res => {
        if (res.success) {
          this.storeForm = res.data
        }

      })
    },
    // 获取经销商列表
    async getDistributorFrom() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        cityArray: this.cityList,
        tableDistributorList: this.tableDistributorList,
        territory_id: this.data.territory_id
      }
      await http.post('/wapi/JurActive/getDistributorFrom', data).then(res => {
        if (res.success) {
          this.distributorForm = res.data
        }

      })
    },
    // 获取机构详情
    async getInstitutionsFromInfo() {
      this.changeIns = true
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id
      }
      await http.post('/wapi/JurActive/getInstitutionsFromInfo', data).then(res => {
        if (res.success) {
          this.basicInfoForm = res.data[0]
          this.locationInfo = []
          this.mydiv = 0
          this.marginValue = 0
          console.log(res.data[0])
          console.log(this.addBasicInfoForm)
          this.getExtendedInfo()
          this.getLocation()
        }

      })
    },
    // 获取门店详情
    async getStoreFromInfo() {
      this.changeIns = true
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_id: this.store_id
      }
      await http.post('/wapi/JurActive/getStoreFromInfo', data).then(res => {
        if (res.success) {
          this.basicInfoForm = res.data[0]
          this.locationInfo = []
          this.mydiv = 0
          this.marginValue = 0
          console.log(res.data[0])
          this.getExtendedInfo2()
          this.getLocation2()


        }

      })
    },
    // 获取经销商详情
    async getDistributorInfoAction() {
      this.changeIns = true
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: this.distributor_id
      }
      await http.post('/wapi/Distributor/getDistributorInfo', data).then(res => {
        if (res.success) {
          this.basicInfoForm = res.data[0]
          this.locationInfo = []
          this.mydiv = 0
          this.marginValue = 0
          console.log(res.data[0])
          this.getExtendedInfo3()
          this.getLocation3()


        }

      })
    },
    fangfa3_1(b) {
      this.distributorGardeList = []
      this.pushDistributorList.distributor_grade_name = ''
      this.getDistributorGardeList(b)
    },
    async getDistributorGardeList(b) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        key: b
      }

      let self = this
      await http.post('/wapi/Distributor/getDistributorGardeList', data).then(res => {

        if (res.success) {
          self.distributorGardeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    fangfa3_2(a) {
      this.distributorCityList = []
      this.pushDistributorList.city_id = ''
      this.getdistributorCityList(a)
    },
    async getdistributorCityList(province_id) {
      let data = this.$store.getters.getDataInfo
      data.province_id = province_id
      data.tenant_id = this.$store.getters.getUser.tenant_id
      let self = this
      await http.post('/wapi/JurActive/getTerritoryCityList', data).then(res => {

        if (res.success) {
          self.distributorCityList = res.data
        } else {
          Message.error(res.message);
        }
      })
    },
    //类别
    async getItitutionTypeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }

      let self = this
      await http.post('/wapi/Institution/getItitutionTypeList', data).then(res => {

        if (res.success) {
          self.TypeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    //类别
    async getStoreTypeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }

      let self = this
      await http.post('/wapi/Retailstore/getRetailstoreTypeList', data).then(res => {

        if (res.success) {
          self.storeTypeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },

    async getRetailstoreGardeList2_1(b) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        key: b
      }

      let self = this
      await http.post('/wapi/Retailstore/getRetailstoreGardeList', data).then(res => {

        if (res.success) {
          self.storeGardeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    fangfa2_1(b) {
      this.storeGardeList = []
      this.pushStoreList.retailstore_grade = ''
      this.getRetailstoreGardeList2_1(b)
    },
    fangfa2(b) {
      this.GardeList = []
      this.addBasicInfoForm.institution_grade = ''
      this.getItitutionGardeList(b)
    },
    //级别
    async getItitutionGardeList(b) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        key: b
      }

      let self = this
      await http.post('/wapi/Institution/getItitutionGardeList', data).then(res => {

        if (res.success) {

          self.GardeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },

    async getItitutionGardeList1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }

      let self = this
      await http.post('/wapi/Institution/getItitutionGardeList1', data).then(res => {

        if (res.success) {

          self.GardeList1 = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    async getRetailstoreGardeList1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }

      let self = this
      await http.post('/wapi/Retailstore/getRetailstoreGardeList1', data).then(res => {

        if (res.success) {
          self.storeGardeList = res.data
        } else {
          Message.error(res.message);
        }
      })
    },
    async getDistributorGardeList1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }

      let self = this
      await http.post('/wapi/Distributor/getDistributorGardeList1', data).then(res => {

        if (res.success) {
          self.distributorGardeList = res.data
        } else {
          Message.error(res.message);
        }
      })
    },
    fangfa2_2(a) {
      this.storeCityList = []
      this.pushStoreList.city_id = ''
      this.getCityList2_2(a)
    },
    async getCityList2_2(province_id) {
      let data = this.$store.getters.getDataInfo
      data.province_id = province_id
      data.tenant_id = this.$store.getters.getUser.tenant_id
      let self = this
      await http.post('/wapi/JurActive/getTerritoryCityList', data).then(res => {

        if (res.success) {
          self.storeCityList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    fangfa(value, option) {
      this.CityList = []
      this.addBasicInfoForm.city_id = ''
      this.getCityList(value)
    },
    //省份列表
    // async getProvinceList() {
    //     let self = this
    //     await http.post('/wapi/Province/getProvinceList').then(res => {
    //         if (res.success) {
    //             self.data1 = res.data
    //         } else {
    //             Message.error(res.message);
    //         }
    //     })
    //
    // },
    async getProvinceList() {
      let self = this
      let data = this.$store.getters.getDataInfo
      data.tenant_id = this.$store.getters.getUser.tenant_id
      await http.post('/wapi/JurActive/getTerritoryProvinceList', data).then(res => {
        if (res.success) {
          self.data1 = res.data
        } else {
          Message.error(res.message);
        }
      })

    },
    //城市
    async getCityList(province_id) {

      let data = this.$store.getters.getDataInfo
      data.province_id = province_id
      data.tenant_id = this.$store.getters.getUser.tenant_id
      let self = this
      await http.post('/wapi/JurActive/getTerritoryCityList', data).then(res => {

        if (res.success) {
          self.CityList = res.data
        } else {
          Message.error(res.message);
        }
      })

    },

    async getCityList1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      let self = this
      await http.post('/wapi/City/getCityList1', data).then(res => {

        if (res.success) {
          self.CityList1 = res.data
        } else {
          Message.error(res.message);
        }
      })

    },
    // 所属经销商
    async getDistributor() {

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        cityArray: this.cityList
      }
      await http.post('/wapi/InstitutionClient/getDistributor', data).then(res => {

        if (res.success) {
          this.distributorList.length = 0
          for (var i = 0; i < res.data.length; i++) {
            this.distributorList.push({
              distributor_id: res.data[i].distributor_id,
              distributor_name: res.data[i].distributor_name
            })
          }
        } else {
          Message.error(res.message);
        }
      })
    },
    // 所属医疗机构
    async getInstitution() {
      if(this.cityList.length ===0){
        return;
      }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        cityArray: this.cityList
      }
      await http.post('/wapi/Institution/getInstitution1', data).then(res => {

        console.log("getInstitution1:",res)
        if (res.success) {
          this.institutionList.length = 0
          for (var i = 0; i < res.data.length; i++) {
            this.institutionList.push({
              institution_id: res.data[i].institution_id,
              institution_name: res.data[i].institution_name
            })
          }
        } else {
          Message.error(res.message);
        }
      })
    },


    // 机构扩展信息
    async getExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id
      }
      await http.post('/wapi/Institution/getExtendedInfo1', data).then(res => {

        if (res.success) {
          this.extendedInfo = res.data
          console.log(this.extendedInfo)
          if (this.extendedInfo.length > 0) {
            for (let i = 0; i < this.extendedInfo.length; i++) {
              this.extendedInfo[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }


        } else {
          Message.error(res.message);

        }
      })
    },
    // 门店扩展信息
    async getExtendedInfo2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        retailstore_id: this.store_id
      }
      await http.post('/wapi/Retailstore/getExtendedInfo', data).then(res => {

        if (res.success) {
          this.extendedInfo2 = res.data
          if (this.extendedInfo2.length > 0) {
            for (let i = 0; i < this.extendedInfo2.length; i++) {
              this.extendedInfo2[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }


        } else {
          Message.error(res.message);

        }
      })
    },
    // 经销商信息
    async getExtendedInfo3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: this.distributor_id
      }
      await http.post('/wapi/Distributor/getExtendedInfo', data).then(res => {

        if (res.success) {
          this.extendedInfo3 = res.data
          if (this.extendedInfo3.length > 0) {
            for (let i = 0; i < this.extendedInfo3.length; i++) {
              this.extendedInfo3[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }


        } else {
          Message.error(res.message);

        }
      })
    },

    // 机构未提交扩展信息
    async getExtendedInfo1_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      await http.post('/wapi/Institution/getExtendedInfo1_1', data).then(res => {

        if (res.success) {
          this.extendedInfo1_2 = res.data
          if (this.extendedInfo1_2.length > 0) {
            for (let i = 0; i < this.extendedInfo1_2.length; i++) {
              this.extendedInfo1_2[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }
        } else {
          // Message.error(res.message);

        }
      })
    },
    // 门店未提交扩展信息
    async getExtendedInfo2_2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      await http.post('/wapi/Retailstore/getExtendedInfo1_1', data).then(res => {

        if (res.success) {
          this.extendedInfo2_2 = res.data
          if (this.extendedInfo2_2.length > 0) {
            for (let i = 0; i < this.extendedInfo2_2.length; i++) {
              this.extendedInfo2_2[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }


        } else {
          // Message.error(res.message);

        }
      })
    },
    // 经销商未提交扩展信息
    async getDistributorExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      await http.post('/wapi/Distributor/getExtendedInfo1_1', data).then(res => {

        if (res.success) {
          this.extendedInfo3_2 = res.data
          if (this.extendedInfo3_2.length > 0) {
            for (let i = 0; i < this.extendedInfo3_2.length; i++) {
              this.extendedInfo3_2[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }


        } else {
          // Message.error(res.message);

        }
      })
    },

    // 机构坐标
    async getLocation() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        reference_id: this.institution_id,
        reference_obj: 'INSTITUTION',
      }
      await http.post('/wapi/Institution/getLocation', data).then(res => {
        if (res.success = true) {
          this.locationInfo = res.data
          this.centers.length = 0;
          this.markers.splice(0, 1, [res.data[0].lng, res.data[0].lat])
          this.locationForm.location_name = res.data[0].location_name
          this.locationForm.address = res.data[0].address
          this.center4_1 = [res.data[0].lng, res.data[0].lat]
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.center = [res.data[0].lng, res.data[0].lat]
              this.centers.push({
                position: [res.data[i].lng, res.data[i].lat],
                events: {
                  click: () => {
                    this.locationForm.location_name = res.data[i].location_name
                    this.locationForm.address = res.data[i].address
                  }
                },
                template: `<div style="width: 22px;color:#fff;height: 30px;text-align:center;line-height: 20px; background:url(${imgUrl})">${i + 1}</div>`
              });
            }
          } else {
            this.center = [116.46, 39.92];
            this.centers.length = 0;
            this.locationForm.location_name = ''
            this.locationForm.address = ''
          }


        }

      })

    },
    // 门店坐标
    async getLocation2() {

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        reference_id: this.store_id,
        reference_obj: 'RETAILSTORE',
      }

      await http.post('/wapi/Institution/getLocation', data).then(res => {
        if (res.success = true) {
          this.centers2.length = 0;
          if (res.data.length > 0) {
            this.locationForm.location_name = res.data[0].location_name
            this.locationForm.address = res.data[0].address
            this.locationInfo = res.data
            this.markers.splice(0, 1, [res.data[0].lng, res.data[0].lat])
            this.center4_1 = [res.data[0].lng, res.data[0].lat]
            for (let i = 0; i < res.data.length; i++) {
              this.center2 = [res.data[0].lng, res.data[0].lat];
              this.centers2.push({
                position: [res.data[i].lng, res.data[i].lat],
                events: {
                  click: () => {
                    this.locationForm.location_name = res.data[i].location_name
                    this.locationForm.address = res.data[i].address
                  }
                },
                template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center; line-height: 20px; background:url(${imgUrl})">${i + 1}</div>`
              });

            }
          } else {
            this.center2 = [116.46, 39.92];
            this.centers2.length = 0;
            this.locationForm.location_name = ''
            this.locationForm.address = ''
          }


        }

      })

    },
    // 经销商坐标
    async getLocation3() {

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        reference_id: this.distributor_id,
        reference_obj: 'DISTRIBUTOR',
      }

      await http.post('/wapi/Institution/getLocation', data).then(res => {
        if (res.success = true) {
          this.centers3.length = 0;
          if (res.data.length > 0) {
            this.locationForm.location_name = res.data[0].location_name
            this.locationForm.address = res.data[0].address
            this.locationInfo = res.data
            this.markers.splice(0, 1, [res.data[0].lng, res.data[0].lat])
            this.center4_1 = [res.data[0].lng, res.data[0].lat]
            for (let i = 0; i < res.data.length; i++) {
              this.center3 = [res.data[0].lng, res.data[0].lat];
              this.centers3.push({
                position: [res.data[i].lng, res.data[i].lat],
                events: {
                  click: () => {
                    this.locationForm.location_name = res.data[i].location_name
                    this.locationForm.address = res.data[i].address
                  }
                },
                template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center; line-height: 20px; background:url(${imgUrl})">${i + 1}</div>`
              });
            }
          } else {
            this.center3 = [116.46, 39.92];
            this.centers3.length = 0;
            this.locationForm.location_name = ''
            this.locationForm.address = ''
          }
        }

      })

    },

    getpois(pois) {
      this.edit_markers1.position = pois
      // Message({
      //     type: 'success',
      //     message: '坐标已更新'
      // })
    },
    // getProductListArray(){
    //     let data = this.$store.getters.getDataInfo
    //     data.tenant_id = this.$store.getters.getUser.tenant_id
    //     http.post('/wapi/JurActive/addProductArray', data).then(res => {
    //         console.log(res.data,5447)
    //         if (res.success) {
    //             this.productList = res.data
    //         } else {
    //             Message.error(res.message);
    //         }
    //     })
    // },
    async getDistributorTypeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }

      let self = this
      await http.post('/wapi/Distributor/getDistributorTypeList', data).then(res => {

        if (res.success) {
          self.distributorTypeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    async getDictionaryListByKOL_LEVEL1() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "INSTITUTION_AGREEMENT_STAGE"
      }
      let self = this
      await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

        if (res.success) {
          self.INSTITUTION_AGREEMENT_STAGE = res.data

        } else {
          Message.error(res.message);
        }

      })
    },

    async getDictionaryListByKOL_LEVEL2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "RETAILSTORE_AGREEMENT_STAGE"
      }
      let self = this
      await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

        if (res.success) {
          self.RETAILSTORE_AGREEMENT_STAGE = res.data

        } else {
          Message.error(res.message);
        }

      })
    },
    async getDictionaryListByKOL_LEVEL3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "DISTRIBUTOR_AGREEMENT_STAGE"
      }
      let self = this
      await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

        if (res.success) {
          self.DISTRIBUTOR_AGREEMENT_STAGE = res.data

        } else {
          Message.error(res.message);
        }

      })
    },
    InstitutionClient(item, j) {
      this.mydiv = j
      this.marginValue = -((j) * 262)
      this.center4_1 = [item.lng, item.lat]
      this.markers.splice(0, 1, [item.lng, item.lat])
      this.locationForm = JSON.parse(JSON.stringify(item))
    },
    locationLeftBut() {

      if (this.mydiv > 1) {
        this.mydiv = this.mydiv - 1
        this.marginValue = this.marginValue + 262;
      } else if (this.mydiv == 1 && this.marginValue == 0) {
        this.mydiv = this.mydiv - 1
        this.marginValue = 0
      } else if (this.mydiv == 1 && this.marginValue < 0) {
        this.mydiv = this.mydiv - 1
        this.marginValue = 0
      }
      this.center4_1 = [this.locationInfo[this.mydiv].lng, this.locationInfo[this.mydiv].lat]
      this.markers.splice(0, 1, [this.locationInfo[this.mydiv].lng, this.locationInfo[this.mydiv].lat])
      this.locationForm.address = this.locationInfo[this.mydiv].address
      this.locationForm.location_name = this.locationInfo[this.mydiv].location_name
    },
    locationRightBut() {
      if (this.mydiv < this.locationInfo.length - 1) {
        this.mydiv = this.mydiv + 1
        this.marginValue = this.marginValue - 262;
      } else {
        this.marginValue = this.marginValue
      }
      this.center4_1 = [this.locationInfo[this.mydiv].lng, this.locationInfo[this.mydiv].lat]
      this.markers.splice(0, 1, [this.locationInfo[this.mydiv].lng, this.locationInfo[this.mydiv].lat])
      this.locationForm.address = this.locationInfo[this.mydiv].address
      this.locationForm.location_name = this.locationInfo[this.mydiv].location_name
    },
    addLocation() {
      if (!this.changeIns && this.activeName == 'first') {
        Message.error('请选择机构');
      } else if (!this.changeIns && this.activeName == 'second') {
        Message.error('请选择门店');
      } else if (!this.changeIns && this.activeName == 'third') {
        Message.error('请选择经销商');
      } else {
        this.markers = []
        this.locationForm = {}
        this.locationInfo.push({
          address: '',
          location_name: ''
        })
        this.mydiv = this.locationInfo.length - 1
        this.marginValue = -((this.mydiv) * 262)
      }
    },
    change1(val) {
      this.locationInfo[this.mydiv].location_name = val
    },
    change2(val) {
      this.locationInfo[this.mydiv].address = val
    },
    async submitLocation(type) {
      this.getUuid1()
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_id: this.data.territory_id,
        reference_obj: type,
        enrollment_id: this.uuid,
        enrollment_type: 'LOCATION',
        user_id: this.$store.getters.getUser.user_id,
        comments: this.jurisdictionForm.textarea,
        owner_id: this.data.owner_id,
        productArray: this.jurisdictionForm.productArray,
        locationArray: this.locationInfo
      }
      if (type == 'DISTRIBUTOR') {
        data.reference_id = this.distributor_id
      } else if (type == 'INSTITUTION') {
        data.reference_id = this.institution_id
      } else if (type == 'RETAILSTORE') {
        data.reference_id = this.store_id
      }
      await http.post('/wapi/v1/submitLocation', data).then(res => {
        if (res.data.success) {
          Message({
            type: 'success',
            message: '提交成功'
          })
          this.steps = 4
          this.stepsName = 3
        } else {
          Message({
            type: 'error',
            message: '提交失败'
          })
        }
      })
    },
  },
  created() {
    this.clientObj = this.$store.getters.getClient
    if (this.clientObj.showInstitution) {
      this.activeName = 'first'
    } else if (!this.clientObj.showInstitution && this.clientObj.showStore) {
      this.activeName = 'second'
    } else if (!this.clientObj.showInstitution && !this.clientObj.showStore && this.clientObj.showDistributor) {
      this.activeName = 'third'
    }
    this.getCity()
    this.systemConfiguration()
    this.getItitutionTypeList()
    this.getDistributorTypeList()
    this.getProvinceList()
    this.getItitutionGardeList1()
    this.getCityList1()

    this.getDictionaryListByKOL_LEVEL1()
    this.getDictionaryListByKOL_LEVEL2()
    this.getDictionaryListByKOL_LEVEL3()
    // this.getProductListArray()
    this.getAdministrativeList()
    this.getProductList1()

  },
  mounted() {

    this.data = this.$store.getters.getDataInfo
    this.getterritoryProductList()

    this.class_active = this.data.class_active
    if (this.class_active) {
      this.whether_text = "mymanagement"
    } else {
      this.whether_text = "myresponsible"
    }
    // console.log(this.data)
    this.getInstutionsList().then(() => {
      this.getInstitutionsFrom()
    })
    this.getRetailstoreList().then(() => {
      this.getStoreFrom()
      this.getInstitution()
    })
    this.getDistributorList().then(() => {
      this.getDistributorFrom()
      this.getDistributor()
    })
    this.getProductList()
    //this.addProductArray_fn()
    this.getinstitution_list()
    this.getstore_list()
    this.getdistributor_list()


  },
  updated() {
  },

}
</script>

<style lang="scss" module>
.container {
  .top {

  }
}
</style>

<style>
.tableSpan {
  border-radius: 4px;
  font-size: 12px;
  display: inline-block;
  padding: 1px 7px;
  background: #c680ff;
  color: white;
  margin-right: 4px;
  margin-top: 4px;
}

.tempCell {
  text-align: center;
}

#steps2 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}

#steps3 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: right;
  padding-left: 20px;
  font-weight: bold;

}

#steps3 .el-tag.el-tag--info {
  background: #FF9901;
  color: #FFFFFF;
  border: none;
}

#steps3 .el-tag.el-tag--info .el-tag__close {
  display: none;
}

#steps4 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: right;
  padding-left: 20px;
  font-weight: bold;

}

#steps2_1 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}

#steps3_1 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: right;
  padding-left: 20px;
  font-weight: bold;

}

#steps3_1 .el-tag.el-tag--info {
  background: #FF9901;
  color: #FFFFFF;
  border: none;
}

#steps3_1 .el-tag.el-tag--info .el-tag__close {
  display: none;
}

#steps4_1 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: right;
  padding-left: 20px;
  font-weight: bold;

}

#steps2_2 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}

#steps3_2 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: right;
  padding-left: 20px;
  font-weight: bold;

}

#steps3_2 .el-tag.el-tag--info {
  background: #FF9901;
  color: #FFFFFF;
  border: none;
}

#steps3_2 .el-tag.el-tag--info .el-tag__close {
  display: none;
}

#steps4_2 .el-form-item__label {
  font-size: 16px;
  color: #000000;
  text-align: right;
  padding-left: 20px;
  font-weight: bold;

}

#resize >>> .el-vue-search-box-container .search-box-wrapper span {
  display: none;
}

.institutions_table_cell {
  color: #2b92fa !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/jurmanage/institutions.vue